import { ApiRequestService } from 'app/BaseFramework/core/http/api-request.service';
import { LookupDataService } from './../../../../BaseFramework/core/http/lookupdata.service';
import { CustomHookService } from './../../../shared-services/custom-hook/custom-hook.service';
import { PolicyServicingAppSettings } from './../../policyServicing-configs/policyServicing-app-settings.config';
import { PolicyAgentDO } from './../../../../FunctionalModules/PolicyIssuance/models/policyAgent.model';
import { PolicyPaymentDO } from './../../../../BaseFramework/shared/models/payment.model';
import { PolicyPremiumBreakupDO } from './../../../../BaseFramework/shared/models/PolicyPremiumBreakup.model';
import { DataTransformService } from './../../../shared-services/data-transform/data-transform.service';
import { GuidGenerator } from './../../../../BaseFramework/core/utilities/commonUtility';
import { PolicyCoverageDO } from 'app/BaseFramework/shared/models/other/policyCoverageDO';
import { SubmissionDataComponent } from './../../../shared-components/submission-data/submission-data.component';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { BehaviorSubject, Subject, forkJoin, Observable, combineLatest, zip } from 'rxjs'
import { concatMap, startWith, take } from 'rxjs/operators'
import { Router, ActivatedRoute } from '@angular/router';
import {
  ValidationUtilService,
  ClaimClientRole,
  InteractService,
  IntimationService,
  ClaimRegistrationService,
  CommonUtilty,
  AppMetadataHandler,
  WorkqueueService
} from 'app'
import { PolicyService } from '../../../../FunctionalModules/PolicyIssuance/policy.service'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import { ComponentOutputDO, IntimationIO, PolicyIO, ProposalIO } from 'app/BaseFramework/shared/models';
import { json } from 'ngx-custom-validators/src/app/json/validator';
import * as moment from 'moment/moment';
// import { default as configData } from './transaction-details.component.json';
//import { default as rulesDataObj } from './sample_rules.json';
import { environment } from 'environments/environment';
import { ClientList } from 'app/ViewModules/shared-components/captured-client-list/captured-client-list.component.js';
import { PolicyCoverageInsuredDO } from './../../../../BaseFramework/shared/models/policyCoverageInsured.model'
import { PolicyCoverageScheduleDO } from '../../../../FunctionalModules/PolicyIssuance/models/PolicyCoverageSchedule.model'

export class TaskIO {
  taskCd: any;
  entityGuid: any;
  objectName: any
  assignedto: any
}
@Component({
  selector: 'app-transaction-details',
  templateUrl: './transaction-details.component.html',
  styleUrls: ['./transaction-details.component.scss']
})
export class TransactionDetailsComponent implements OnInit {

  constructor(
    private message: NzMessageService,
    private modalService: NzModalService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private validationUtilService: ValidationUtilService,
    private interactService: InteractService,
    private intimationService: IntimationService,
    private claimRegistrationService: ClaimRegistrationService,
    private commonUtilty: CommonUtilty,
    public appMetadataHandler: AppMetadataHandler,
    private workqueueService: WorkqueueService,
    private policyService: PolicyService,
    private dataTransformService: DataTransformService,
    public policyServicingAppSettings: PolicyServicingAppSettings,
    private customHookService: CustomHookService,
    private lookupDataService: LookupDataService,
    private apiRequestService: ApiRequestService
  ) {
    /* Set State (If passed from other routes. Eg: New-Intimation) */
    let newState = this.route.snapshot.paramMap.get('from');
    // if (newState) this.state = newState;
    // console.log("[state] -- ", this.state);
    this.nullifyPayloadInEdit = 'start'
  }

  public currencyOptions = {
    prefix: this.appMetadataHandler.baseCurrencyPREFIX,
    thousands: this.appMetadataHandler.THOUSANDS_SEPARATOR,
    decimal: this.appMetadataHandler.DECIMAL_SEPARATOR,
    align: this.appMetadataHandler.currencyAlignment
  }

  transactionForm = this.fb.group({})
  tempJosn: any;
  nomineeClaimantFlag: any = false;
  lookupsToBind = ['roleUsers', 'csrUsersUID', 'claimRegRoleUsers', 'decisionTypeCd', 'decisionCd', 'manualUwDecisionCd','uwDecisionCd', 'uwRuleSubType', 'autoUwRuleCd']
  lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)
  assigneeUser: any = null
  // dummyJsonIntimation = this.configData.dummyJsonIntimation
  TRUEVALUE = true;
  FALSEVALUE = false
  modSearchCustomerInsured: boolean;
  modSearchCustomerPrimaryInsured: boolean;
  modSearchCustomerPayer: boolean;
  modSearchCustomerOwner: boolean;
  modSearchCustomerVehicle: boolean;
  modSearchCustomerMembers: boolean;
  modSearchAgent: boolean;
  tempInVisible = false;
  tempAgentDetail = [];
  sumInsured = 100000;
  setRolesBeneficiary = "Payer";
  productData = []
  otherListNode = null;
  state
  enableModalClose
  refreshThisComponenetOnSaveSubmit = true
  refreshBasePlanToggle = true;
  refreshMandatoryCoveragesToggle = true;
  refreshAdditionalCoveragesToggle = true;
  mandatoryCoveragesList = [];
  maxDepth = "4";
  basePlanComponentData = {};
  additionalCoveragesComponentData = {};
  noOfClientsCanBeAdded = {};

  getPackageType(data) {
    console.log("fetched package type", data);
    let clientCountMapping = this.configData.clientCountMapping;
    for (const key in clientCountMapping) {
      if (data === key)
        this.noOfClientsCanBeAdded = clientCountMapping[key]
    }
  }

  refreshComponents() {
    this.refreshThisComponenetOnSaveSubmit = false
    setTimeout(() => {
      this.refreshThisComponenetOnSaveSubmit = true
    }, 500);
  }

  _toggleRefreshBasePlanComponent(value) {
    if (value) {
      this.refreshBasePlanToggle = false;
      setTimeout(() => { this.refreshBasePlanToggle = true; }, 300);
    }
  }

  _toggleRefreshMandatoryCoveragesComponent(value) {
    if (value) {
      this.refreshMandatoryCoveragesToggle = false;
      setTimeout(() => { this.refreshMandatoryCoveragesToggle = true; }, 300);
    }
  }

  _toggleRefreshAdditionalCoveragesComponent(value) {
    if (value) {
      this.refreshAdditionalCoveragesToggle = false;
      setTimeout(() => { this.refreshAdditionalCoveragesToggle = true; }, 300);
    }
  }

  subscribeAndRefreshCoveragesComponent() {
    if (this.toggleInsuredListSubject$ != null) this.toggleInsuredListSubject$.unsubscribe();
    this.toggleInsuredListSubject$ = this.interactService.addClientSubject$.subscribe(val => {
      if (val)
        this._toggleRefreshAdditionalCoveragesComponent(true);
    })
  }

  private transactionMasterUpdateControl = true;
  flattenedPayloadInEdit
  private _payloadInEdit = null
  set payloadInEdit(value: any) {
    if (this._payloadInEdit == null) {
      this._payloadInEdit = this.commonUtilty.deepCopy(value)
    }
    else {
      throw "You cannot set payloadInEdit, since it's a constant and can be initialized only once"
    }
  }

  get payloadInEdit() {
    return this._payloadInEdit
  }

  set nullifyPayloadInEdit(value: any) {
    this._payloadInEdit = null
  }

  

  mapperTransactionState = this.appMetadataHandler.APPCONSTANTS.nbuDefaultState;
  // _inputClaimsBasicDetailsComponent = null;
  TransactionState = null;
  inboxType = null;
  taskId = null;
  proposalType = this.appMetadataHandler.APPCONSTANTS.proposalType;
  productFamilyCd = null;
  selectedProduct = null;
  refreshCoveragesDecision = true;
  givenPolicyDecision: any;


  ngOnDestroy() {
    this.interactService.nullifyTransactionEmitters();
    this.nullifyPayloadInEdit = 'start';
    if (this.commonUtilty.isArrayIterable(this.lookupDataService.lookupCacheMap['insuredCd']))
      this.lookupDataService.lookupCacheMap['insuredCd'] = [];
    if (this.commonUtilty.isArrayIterable(this.lookupDataService.lookupCacheMap['additionalCoveragesCd']))
      this.lookupDataService.lookupCacheMap['additionalCoveragesCd'] = [];
    if (this.commonUtilty.isArrayIterable(this.lookupDataService.lookupCacheMap['mandatoryCoveragesCd']))
      this.lookupDataService.lookupCacheMap['mandatoryCoveragesCd'] = [];

  }

  initializeIntimationTabs() {
    this.transactionForm = this.fb.group({
    });
  }

  setFooter(data) {
    this.ClientCaptureFooter = data
  }

  enableTabFor(states) {
    let c = states.includes(this.mapperTransactionState)
    return c
  }

  disableTabFor(states) {
    let c = states.includes(this.mapperTransactionState)
    return !c
  }

  tabStates: any;

  getTabVisibilityStatus(tabKey) {
    let tabKeyMetaData = this.tabStates[tabKey]
    console.log(tabKeyMetaData)
    console.log(tabKey)
    console.log(tabKeyMetaData.enableTab)
    if (tabKeyMetaData.enableTab) {
      return this.enableTabFor(tabKeyMetaData.states)
    }
    else {
      return this.disableTabFor(tabKeyMetaData.states)
    }
  }

  initializeTransactionPageDataStateMap(mapperTransactionState, configData) {
    let listOfAllChildren = this.getListOfChildrenForCurrentState(mapperTransactionState, configData);
    let trasactionPageDataStateMap = {}
    trasactionPageDataStateMap[mapperTransactionState] = {}
    trasactionPageDataStateMap[mapperTransactionState]["components"] = {}
    let components = {}
    if (listOfAllChildren && Array.isArray(listOfAllChildren) && listOfAllChildren.length > 0) {
      listOfAllChildren.forEach(child => {
        components[child] = new Subject()
      })
    }
    trasactionPageDataStateMap[mapperTransactionState]["components"] = components

    return trasactionPageDataStateMap
  }

  listOfAllChildren
  private getListOfChildrenForCurrentState(mapperTransactionState: any, configData: any) {
    let defaultChildrenComponents = configData.StateToChildComponentMapper.allStates;
    let specificChildrenComponents = configData.StateToChildComponentMapper[mapperTransactionState];
    let listOfAllChildren = [...defaultChildrenComponents, ...specificChildrenComponents];
    return listOfAllChildren
  }


  trasactionPageDataStateMap: any = {
    claimIntimation: {
      components: {
        ClaimsBasicDetailsComponent: new Subject(),
        CapturedPolicyListComponent: new Subject(),
        CapturedClientListComponentNOMINEE: new Subject(),
        CapturedClientListComponentCLAIMANT: new Subject(),
        InsuredDetailsComponent: new Subject(),
        DocumentManagerComponent: new Subject()
      }
    },
    claimRegistration: {
      components: {
        ClaimsBasicDetailsComponent: new Subject(),
        CapturedPolicyListComponent: new Subject(),
        CapturedClientListComponentNOMINEE: new Subject(),
        CapturedClientListComponentCLAIMANT: new Subject(),
        InsuredDetailsComponent: new Subject(),
        DocumentManagerComponent: new Subject()
      }
    },
    claimAdjudication: {
      components: {
        ClaimsBasicDetailsComponent: new Subject(),
        CapturedPolicyListComponent: new Subject(),
        CapturedClientListComponentNOMINEE: new Subject(),
        CapturedClientListComponentCLAIMANT: new Subject(),
        InsuredDetailsComponent: new Subject(),
        DocumentManagerComponent: new Subject(),
        ClaimDecisionComponent: new Subject(),
        ClaimsBenefitComponent: new Subject() //Transform Breaking with error 500
      }
    },
    claimInvestigation: {
      components: {
        ClaimsBasicDetailsComponent: new Subject(),
        CapturedPolicyListComponent: new Subject(),
        CapturedClientListComponentNOMINEE: new Subject(),
        CapturedClientListComponentCLAIMANT: new Subject(),
        InsuredDetailsComponent: new Subject(),
        DocumentManagerComponent: new Subject(),
      }
    },
    claimPayout: {
      components: {
        ClaimsBasicDetailsComponent: new Subject(),
        CapturedPolicyListComponent: new Subject(),
        CapturedClientListComponentNOMINEE: new Subject(),
        CapturedClientListComponentCLAIMANT: new Subject(),
        InsuredDetailsComponent: new Subject(),
        DocumentManagerComponent: new Subject(),
      }
    },
    claimUWReferral: {
      components: {
        ClaimsBasicDetailsComponent: new Subject(),
        CapturedPolicyListComponent: new Subject(),
        CapturedClientListComponentNOMINEE: new Subject(),
        CapturedClientListComponentCLAIMANT: new Subject(),
        InsuredDetailsComponent: new Subject(),
        DocumentManagerComponent: new Subject(),
        ClaimDecisionComponent: new Subject(),
        ClaimsBenefitComponent: new Subject()
      }
    },
    claimReinsReferral: {
      components: {
        ClaimsBasicDetailsComponent: new Subject(),
        CapturedPolicyListComponent: new Subject(),
        CapturedClientListComponentNOMINEE: new Subject(),
        CapturedClientListComponentCLAIMANT: new Subject(),
        InsuredDetailsComponent: new Subject(),
        DocumentManagerComponent: new Subject(),
        ClaimDecisionComponent: new Subject(),
        ClaimsBenefitComponent: new Subject()
      }
    },
    proposal_ManualUw: {
      components: {
        CapturedClientListComponentINSURED: new Subject(),
        CapturedClientListComponentPRIMARYINSURED: new Subject(),
        CapturedClientListComponentOWNER: new Subject(),
        CapturedClientListComponentPAYER: new Subject(),
        CapturedClientListComponentNOMINEE: new Subject(),
        MulticaptureBankDetailsComponent: new Subject(),
        UnderwritingDecisionComponent: new Subject(),
        CapturedAgentListComponent: new Subject()
      }
    },
    policyDataEntryTask: {
      components: {
        CapturedClientListComponentINSURED: new Subject(),
        CapturedClientListComponentPRIMARYINSURED: new Subject(),
        CapturedClientListComponentOWNER: new Subject(),
        SubmissionDataComponent: new Subject(),
        ProductCoveragesComponent: new Subject(),
        OtherPolicyComponent: new Subject(),
        CapturedAgentListComponent: new Subject()
        // CapturedClientListComponentAGENT: new Subject()
        // CapturedClientListComponentPAYER: new Subject(),
        // CapturedClientListComponentNOMINEE: new Subject(),
        // MulticaptureBankDetailsComponent: new Subject(),
        // UnderwritingDecisionComponent: new Subject()
      }
    }
  }

  trasactionChildComponentTabPlacementMap = {
    ClaimsBasicDetailsComponent: 0,
    CapturedPolicyListComponent: 0,
    CapturedClientListComponentNOMINEE: 2,
    CapturedClientListComponentCLAIMANT: 2,
    InsuredDetailsComponent: 1,
    ClaimDecisionComponent: 6,
  }

  EmitterStatus = {}
  attemptForTransaction(transactionSaveType) {
    this.interactService.transactionCloserState(transactionSaveType)
    this.askAllChildrenForData(this.listOfAllChildren)
    this.emitterFailureHandler();
  }

  emitterStatusModal = false
  emitterStatusForView = []
  private emitterFailureHandler() {
    this._transactionInProgress = false; // Stop the Loader State of transaction
    let emitterStatus = this.EmitterStatus // take snapshot of current emitter status
    for (const key in emitterStatus) {
      emitterStatus[key]['componentName'] = key
    }
    emitterStatus = this.commonUtilty.convertMapToArray(emitterStatus)

    this.emitterStatusForView = this.commonUtilty.deepCopy(emitterStatus)
    localStorage.setItem("EMITTERSTATUSERROR", JSON.stringify(this.emitterStatusForView))
    if (this.emitterStatusForView.some(es => !es.emitted)) {
      if (!environment.production)
        this.emitterStatusModal = true
      this.message.error("Configuration Error - Technical issue occurred, please contact IT Support.");
    }
  }

  dummySubmit() {
    if (this.payloadInEdit) {
      let DOName = this._getDOName(this.mapperTransactionState)
      if (this.payloadInEdit[DOName]) {
        this.payloadInEdit[DOName].uwDecisionCd = 'STANDARD'
        this.payloadInEdit[DOName].premiumBreakupList = null

        if (this.payloadInEdit[DOName]['caseCoverages'] &&
          this.commonUtilty.isArrayIterable(this.payloadInEdit[DOName]['caseCoverages'])) {
          this.payloadInEdit[DOName]['caseCoverages'].forEach(coverage => {
            coverage.uwDecisionCd = 'STANDARD'

            if (coverage['caseCoverageInsureds'] &&
              this.commonUtilty.isArrayIterable(coverage['caseCoverageInsureds'])) {
              coverage['caseCoverageInsureds'].forEach(coverageInsured => {
                coverageInsured.uwDecisionCd = 'STANDARD'
              });
            }
          });
        }
      }
    }

    this.message.loading('Submitting', { nzDuration: 4000 });
    this.submitCase(this.payloadInEdit);
  }

  askAllChildrenForData(listOfEmitterChildren) {
    this.interactService.pingChildToReact(listOfEmitterChildren)
  }

  getChildrenSubscriberDataPipe() {
    let childrenSubscribers$ = []
    if (this.mapperTransactionState) {
      let components = this.trasactionPageDataStateMap[this.mapperTransactionState].components
      // components['MulticaptureBankDetailsComponent'] = new Subject()
      if (!this.appMetadataHandler.featureFlags.enableAutoInitializeTransformDataPipe) components['MulticaptureBankDetailsComponent'] = new Subject()
      for (const key in components) {
        if (components.hasOwnProperty(key)) {
          childrenSubscribers$.push(components[key]);
        }
      }
    }

    if (childrenSubscribers$.length == Object.keys(this.trasactionPageDataStateMap[this.mapperTransactionState].components).length)
      return childrenSubscribers$
    else
      throw new Error("Number of Subject Mappers Do not Match Number of childrenSubscribers")
  }

  getChildrenNumber() {
    let count = null
    if (this.trasactionPageDataStateMap &&
      this.trasactionPageDataStateMap[this.mapperTransactionState] &&
      this.trasactionPageDataStateMap[this.mapperTransactionState]['components'] &&
      this.trasactionPageDataStateMap[this.mapperTransactionState]['components']
    ) {
      let c = Object.keys(this.trasactionPageDataStateMap[this.mapperTransactionState]['components'])
      count = c.length
    }

    console.log("count", count)
    return count
  }

  childrenDataPipeSubscription$
  initializeChildSubscribers() {
    let childrenDataPipe = this.getChildrenSubscriberDataPipe()
    let childNo = this.getChildrenNumber();
    console.log("children data pipe length", childrenDataPipe.length);
    console.log("children no ", childNo);
    if (childrenDataPipe.length === this.getChildrenNumber()) {
      if (this.childrenDataPipeSubscription$ != null) this.childrenDataPipeSubscription$.unsubscribe()
      this.childrenDataPipeSubscription$ = zip(...childrenDataPipe).subscribe(responses => {

        console.log((Object.keys(this.emitterHistory).length + " count of object"));
        if (Object.keys(this.emitterHistory).length === this.getChildrenNumber())
          this._intimationTransformUItoServer(responses)
        else {
          if (!environment.production) {
            throw "Missing Subject for a component that's emitting data. Check transactionPageDataStateMap or _BaseEmitterHandler.";

          }
        }
      })
    }
    else {
      throw "Component Emitters Mismatch";

    }
  }

  emitterHistory = {}
  _BaseEmitHandler(data, componentName) {
    console.log("BaseEmitHandler Fired For " + componentName)
    if (!this.appMetadataHandler.featureFlags.enableUsageOfDataTransformService) this.emitterHistory[componentName] = data
    else if (this.appMetadataHandler.featureFlags.enableUsageOfDataTransformService) this.dataTransformService.emitterHistory[componentName] = data
    if (this.trasactionPageDataStateMap &&
      this.trasactionPageDataStateMap[this.mapperTransactionState] &&
      this.trasactionPageDataStateMap[this.mapperTransactionState]['components'] &&
      this.trasactionPageDataStateMap[this.mapperTransactionState]['components'][componentName]
    ) {
      this.EmitterStatus[componentName] = { emitted: true, isExtra: !!!(this.listOfAllChildren.find(lc => lc == componentName)) }
      this.trasactionPageDataStateMap[this.mapperTransactionState]['components'][componentName].next(data);
    }
    else {
      console.warn(`A Component - ${componentName} emitted data but as per Data Pipeline is not valid for serviceTask ${this.mapperTransactionState}`)
    }
    if (!this.appMetadataHandler.featureFlags.enableUsageOfDataTransformService) {
      let childrenNumber = this.getChildrenNumber()
      if (Object.keys(this.emitterHistory).length === childrenNumber) {
        console.log("All Childrem emitted data")
        console.log(this.emitterHistory)
      }
    }
    else if (this.appMetadataHandler.featureFlags.enableUsageOfDataTransformService) {
      let childrenNumber = this.dataTransformService.getChildrenNumber(this.trasactionPageDataStateMap, this.mapperTransactionState)
      if (Object.keys(this.dataTransformService.emitterHistory).length === childrenNumber) {
        console.log("All Childrem emitted data")
        console.log(this.dataTransformService.emitterHistory)
      }
    }
  }
  // _BaseEmitHandler(data, componentName) {
  //   console.log("BaseEmitHandler Fired For " + componentName)
  //   this.emitterHistory[componentName] = data
  //   if (this.trasactionPageDataStateMap &&
  //     this.trasactionPageDataStateMap[this.mapperTransactionState] &&
  //     this.trasactionPageDataStateMap[this.mapperTransactionState]['components'] &&
  //     this.trasactionPageDataStateMap[this.mapperTransactionState]['components'][componentName]
  //   ) {
  //     this.EmitterStatus[componentName] = { emitted: true, isExtra: !!!(this.listOfAllChildren.find(lc => lc == componentName)) }
  //     this.trasactionPageDataStateMap[this.mapperTransactionState]['components'][componentName].next(data);
  //   }
  //   else {
  //     console.warn(`A Component - ${componentName} emitted data but as per Data Pipeline is not valid for serviceTask ${this.mapperTransactionState}`)
  //   }
  //   if (Object.keys(this.emitterHistory).length === this.getChildrenNumber()) {
  //     console.log("All Childrem emitted data")
  //     console.log(this.emitterHistory)
  //   }
  // }

  getBasicDetails(data) {
    console.log(data)
  }

  _transactionInProgress = false
  _UIErrorList = []
  _intimationTransformUItoServer(responses) {
    let ErrorList = []
    this._transactionInProgress = true
    let payload = null
    if (responses != null && !responses) {
      if (this.payloadInEdit != null) {
        payload = this.payloadInEdit // Editmode
      }
      else {

        if (this.TransactionState == 'policyDataEntryTask') {
          payload = new ProposalIO();
        } else {
          payload = new IntimationIO()
          payload = this._setSubmissionModeFromUI(payload)
        }
      }
      responses.forEach((response: any) => {
        if (response.componentName === 'ClaimsBasicDetailsComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._ClaimsBasicDetailsComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._ClaimsBasicDetailsComponentToSeverDOMapper(payload, response)
          }
        }
        if (response.componentName === 'CapturedPolicyListComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._CapturedPolicyListComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._CapturedPolicyListComponentToSeverDOMapper(payload, response)
          }
        }
        if (response.componentName === 'CapturedClientListComponent' || response.componentName === 'InsuredDetailsComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (response.componentData && !!!response.componentData.isInvalid)
              payload = this._CapturedClientListComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._CapturedClientListComponentToSeverDOMapper(payload, response)
          }
        }
        if (response.componentName === 'CapturedAgentListComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (response.componentData && !!!response.componentData.isInvalid)
              payload = this._CapturedAgentListComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._CapturedAgentListComponentToSeverDOMapper(payload, response)
          }
        }
        if (response.componentName === 'DocumentManagerComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._DocumentManagerComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._DocumentManagerComponentToSeverDOMapper(payload, response)
          }
        }
        if (response.componentName === 'ClaimDecisionComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._ClaimDecisionComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._ClaimDecisionComponentToSeverDOMapper(payload, response)
          }
        }
        if (response.componentName === 'UnderwritingDecisionComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._UnderwritingDecisionComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._UnderwritingDecisionComponentToSeverDOMapper(payload, response)
          }
        }
        if (response.componentName === 'SubmissionDataComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._SubmissionDataComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._SubmissionDataComponentToSeverDOMapper(payload, response)
          }
        }
        if (response.componentName === 'ProductCoveragesComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._ProductCoveragesComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._ProductCoveragesComponentToSeverDOMapper(payload, response)
          }
        }
        if (response.componentName === 'OtherPolicyComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._OtherPoliciesComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._OtherPoliciesComponentToSeverDOMapper(payload, response)
          }
        }
        if (response.componentName === 'ClaimsBenefitComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._ClaimsBenefitComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._ClaimsBenefitComponentToSeverDOMapper(payload, response)
          }
        }
        if (response.componentName === 'MulticaptureBankDetailsComponent' || response.componentName === 'ClaimsPaymentBreakupComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._MulticaptureBankDetailsComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._MulticaptureBankDetailsComponentToSeverDOMapper(payload, response)
          }
        }

        /**
         * WARNING: Do not make any change to Generic Transform Implementation.
         * If you want your component to use Generic Transform, just add your component name to 
         * transaction-detail.component.json to 'GenericTransformComponentList'
         */
        if (this.configData.GenericTransformComponentList && this.configData.GenericTransformComponentList.includes(response.componentName)) {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._GenericComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._GenericComponentToSeverDOMapper(payload, response)
          }
        }

      });
    }

    if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform && ErrorList) {
      this._UIErrorList = this.commonUtilty.deepCopy(ErrorList)
    }
    if (payload != null && Array.isArray(this._UIErrorList) && this._UIErrorList.length == 0) {
      if (this.appMetadataHandler.featureFlags.enableMarkAllRequirementsAsReceived)
        payload = this.___markAllRequirementsAsReceived(payload)
      if (this.appMetadataHandler.featureFlags.enableMarkAllChecklistAsCompleted)
        payload = this.___markAllChecklistAsCompleted(payload)

      console.log("TransactionState " + this.TransactionState);
      if (this.TransactionState === 'claimIntimation')
        this._saveOrSubmitIntimationTransaction(payload);

      //TODO check with ganesh and ninad

      if (this.TransactionState == 'claimAdjudication')
        this._saveOrSubmitAdjudicationTransaction(payload);
      else if (this.TransactionState == 'proposal_ManualUw') {
        this._saveOrSubmitCaseTransaction(payload)
      }
      else if (this.TransactionState == 'policyDataEntryTask') {
        this._saveOrSubmitPolicyTransaction(payload)
      }
      else if (this.TransactionState !== 'claimIntimation' && this.TransactionState !== 'claimInvestigation')
        this._saveOrSubmitRegistrationTransaction(payload);
    }
    else if (!environment.production) {
      // throw new Error("Unexpected Error - Empty Payload")
    }


  }

  private _saveOrSubmitIntimationTransaction(payload: any) {
    if (payload) {

      this.interactService.transactionCloserSubject$
        .pipe(take(1))
        .subscribe(resp => {
          if (resp && resp == 'save') {
            this.message.loading('Saving', { nzDuration: 4000 });
            this.saveIntimation(payload)
          }
          if (resp && resp == 'submit') {
            this.message.loading('Submitting', { nzDuration: 4000 });
            this.submitIntimation(payload);
          }
        })
    }
    else {
      throw "Error while creating Save Intimation Payload."
    }
  }

  private _saveOrSubmitPolicyTransaction(payload: any) {
    if (payload) {

      this.interactService.transactionCloserSubject$
        .pipe(take(1))
        .subscribe(resp => {
          if (resp && resp == 'save') {
            this.message.loading('Saving', { nzDuration: 4000 });
            this.savePolicy(payload)
          }
          if (resp && resp == 'submit') {
            this.message.loading('Submitting', { nzDuration: 4000 });
            this.submitPolicy(payload);
          }
        })
    }
    else {
      throw "Error while creating Save Policy Payload."
    }
  }

  private _saveOrSubmitCaseTransaction(payload: any) {
    if (payload) {

      this.interactService.transactionCloserSubject$
        .pipe(take(1))
        .subscribe(resp => {
          if (resp && resp == 'save') {
            this.message.loading('Saving', { nzDuration: 4000 });
            this.saveCase(payload)
          }
          if (resp && resp == 'submit') {
            this.message.loading('Submitting', { nzDuration: 4000 });
            this.submitCase(payload);
          }
        })
    }
    else {
      throw "Error while creating Save Policy Payload."
    }
  }

  savePolicy$ = null
  savePolicy(payload) {
    if (this.savePolicy$) this.savePolicy$.unsubscribe()
    this.savePolicy$ = this.policyService.savePolicies(payload).subscribe(resp => {
      this._postSaveHandler(resp);
    });
  }
  submitPolicy$ = null
  submitPolicy(payload) {
    if (this.submitPolicy$) this.submitPolicy$.unsubscribe()
    this.submitPolicy$ = this.policyService.submitPolicies(payload).subscribe(resp => {
      this._postSubmitHandler(resp);
    });
  }

  saveCase$ = null
  saveCase(payload) {
    if (this.savePolicy$) this.savePolicy$.unsubscribe()
    this.savePolicy$ = this.policyService.saveCase(payload).subscribe(resp => {
      this._postSaveHandler(resp);
    });
  }

  submitCase$ = null
  submitCase(payload) {
    if (this.submitPolicy$) this.submitPolicy$.unsubscribe()
    this.submitPolicy$ = this.policyService.submitCase(payload).subscribe(resp => {
      this._postSubmitHandler(resp);
    });
  }


  saveIntimation$ = null
  saveIntimation(payload) {
    if (this.saveIntimation$) this.saveIntimation$.unsubscribe()
    this.saveIntimation$ = this.intimationService.saveIntimation(payload).subscribe(resp => {
      this._postSaveHandler(resp);
    });
  }
  submitIntimation$ = null
  submitIntimation(payload) {
    if (this.submitIntimation$) this.submitIntimation$.unsubscribe()
    this.submitIntimation$ = this.intimationService.submitIntimation(payload).subscribe(resp => {
      this._postSubmitHandler(resp);
    });
  }
  saveRegistrationObservable = null
  private _saveOrSubmitRegistrationTransaction(payload: any) {
    if (payload) {
      if (this.saveRegistrationObservable)
        this.saveRegistrationObservable.unsubscribe();
      this.message.loading('Saving', { nzDuration: 4000 });
      this.interactService.transactionCloserSubject$
        .pipe(take(1))
        .subscribe(resp => {
          if (resp && resp == 'save') {
            this.message.loading('Saving', { nzDuration: 4000 });
            this.saveRegistration(payload)
          }
          if (resp && resp == 'submit') {
            this.message.loading('Submitting', { nzDuration: 4000 });
            this.submitRegistration(payload);
          }
        })


    }
    else {
      throw "Error while creating Save Intimation Payload."
    }
  }




  private _saveOrSubmitAdjudicationTransaction(payload: any) {

    if (payload) {
      if (this.saveRegistrationObservable)
        this.saveRegistrationObservable.unsubscribe();

      this.interactService.transactionCloserSubject$
        .pipe(take(1))
        .subscribe(resp => {
          if (resp && resp == 'save') {
            this.message.loading('Saving', { nzDuration: 4000 });
            this.saveAdjudication(payload)
          }
          if (resp && resp == 'submit') {
            this.message.loading('Submitting', { nzDuration: 4000 });
            this.submitAdjudication(payload);
          }
        })


    }
    else {
      throw "Error while creating Save Intimation Payload."
    }
  }
  saveRegistration(payload) {
    this.claimRegistrationService.saveClaimRegistration(payload).subscribe(resp => {
      this._postSaveHandler(resp);
    });
  }

  submitRegistration(payload) {
    this.claimRegistrationService.submitClaimRegistration(payload).subscribe(resp => {
      this._postSubmitHandler(resp);
    });
  }

  saveAdjudication(payload) {
    this.claimRegistrationService.saveAdjudication(payload).subscribe(resp => {
      this._postSaveHandler(resp);
    });
  }

  submitAdjudication(payload) {
    this.claimRegistrationService.submitAdjudition(payload).subscribe(resp => {
      this._postSubmitHandler(resp);
    });
  }

  private _postSaveHandler(resp: any) {
    this._transactionInProgress = false
    console.log(JSON.stringify(resp))
    if (resp && Object.entries(resp).length > 0 && !resp['errormesage']) {
      let DOName = this._getDOName(this.mapperTransactionState)
      this.nullifyPayloadInEdit = 'start';
      this.refreshComponents()
      if (DOName === 'intimationDO' && resp && resp[DOName] && resp[DOName]['clmIntimationNum'])
        this.message.success(`Intimation(${resp[DOName]['clmIntimationNum']}) has been saved`, { nzDuration: 4000 })

      if (DOName === 'claimDO' && resp && resp[DOName] && resp[DOName]['claimNum'])
        this.message.success(`Claim(${resp[DOName]['claimNum']}) has been saved`, { nzDuration: 4000 })

      if ((DOName === 'proposalDO' || DOName === 'caseDO') && resp && resp[DOName] && resp[DOName]['proposalNum'])
        this.message.success(`Proposal(${resp[DOName]['proposalNum']}) has been saved`, { nzDuration: 4000 })

      this._intimationTransformServerToUI(resp);
      this.payloadInEdit = this.commonUtilty.deepCopy(resp);
      this.interactService.sendGenericData(this.payloadInEdit);
      this.interactService.sendPolicyListToInsured(this.payloadInEdit)
      this.interactService.sendClaimIOForDocumentManager(this.payloadInEdit);
      this.interactService.pingForRefreshBasePlan();
      // this.interactService.pingForRefreshCoverages();
    }
    else {
      this.message.error('Server Error - Technical issue occurred, please contact IT Support.')
    }

  }

  private _postSubmitHandler(resp: any) {
    this._transactionInProgress = false
    if (resp && Object.entries(resp).length > 0 && !resp['errormesage']) {
      let DOName = this._getDOName(this.mapperTransactionState)
      this.nullifyPayloadInEdit = 'start';
      this.refreshComponents()
      if (DOName === 'intimationDO' && resp && resp[DOName] && resp[DOName]['clmIntimationNum'])
        this.message.success(`Intimation(${resp[DOName]['clmIntimationNum']}) has been submitted'`, { nzDuration: 4000 })

      if (DOName === 'claimDO' && resp && resp[DOName] && resp[DOName]['claimNum'])
        this.message.success(`Claim(${resp[DOName]['claimNum']}) has been submitted'`, { nzDuration: 4000 })

      if (DOName === 'proposalDO' && resp && resp[DOName] && resp[DOName]['proposalNum'])
        this.message.success(`Proposal(${resp[DOName]['proposalNum']}) has been submitted'`, { nzDuration: 4000 })
      if (DOName === 'caseDO' && resp && resp[DOName] && resp[DOName]['proposalNum'])
        this.message.success(`Policy(${resp[DOName]['proposalNum']}) has been submitted'`, { nzDuration: 4000 })

      if (resp && resp.exceptionDOList && resp.exceptionDOList.length <= 0) {
        this.router.navigate(['/app/nbu/inbox/workbench'])
        //Separate Convert Call Removed from here.
      }
      else {
        // this._intimationTransformServerToUI(resp);
        if (this.appMetadataHandler.featureFlags.demoChange) {
          this.message.success(`Policy(${this.payloadInEdit[DOName]['proposalNum']}) has been submitted'`, { nzDuration: 4000 })
          this.router.navigate(['/app/nbu/inbox/workbench'])
        }
        else {

        }
        // this.payloadInEdit = this.commonUtilty.deepCopy(resp);

      }
    }
    else {
      this.message.error('Server Error - Technical issue occurred, please contact IT Support.')
    }

  }

  _extractSubmissionModeFromIO(payload) {
    let DOName = this._getDOName(this.TransactionState)
    if (payload && payload[DOName]) {
      return payload[DOName]['intimationSourceCd']
    }

  }

  _setSubmissionModeFromUI(payload) {
    let DOName = this._getDOName(this.TransactionState)
    if (payload && payload[DOName]) {
      payload[DOName]['intimationSourceCd'] = this._intimationSourceCd
    }
    return payload
  }

  _intimationTransformServerToUI(serverIO) {
    this._intimationSourceCd = this._extractSubmissionModeFromIO(serverIO)
    this._inputClaimsBasicDetailsComponent = this._ClaimsBasicDetailsServerDOToComponentMapper(serverIO)
    this._inputCapturedPolicyListComponent = this._CapturedPolicyListServerDOToComponentMapper(serverIO)
    this._inputAllClientListComponent = this._CapturedClientListServerDOToComponentMapper(serverIO)
    this._inputDocumentManagerComponent = this._DocumentManagerDOToComponentMapper(serverIO)
    this._inputClaimDecisionComponent = this._ClaimDecisionDOToComponentMapper(serverIO)
    this._inputUnderwritingDecisionComponent = this._UnderwritingDecisionDOToComponentMapper(serverIO)
    this._inputClaimsBenefitComponent = this._ClaimsBenefitDOToComponentMapper(serverIO)
    this._inputMulticaptureBankDetailsComponent = this._MulticaptureBankDetailsToComponentMapper(serverIO)
    this._inputOtherPoliciesComponent = this._OtherPoliciesDOToComponentMapper(serverIO);
    console.log("_inputOtherPoliciesComponent", JSON.stringify(this._inputOtherPoliciesComponent));
    this._inputProductCoveragesComponent = this._ProductCoveragesToComponentMapper(serverIO)
    //below transform calls are not verified and approved by Ninad
    this._inputSubmissionDataComponent = this._SubmissionDataComponentMapper(serverIO);
    this._inputAgentListComponent = this._CapturedAgentListServerDOToComponentMapper(serverIO);
    this._inputInsuredCoverageDecisionComponent = this._GenericDOToComponentMapper(serverIO)
    return this.getTransactionGuid(serverIO)




  }

  _ClaimsBasicDetailsComponentToSeverDOMapper(payload, response) {
    let DOName = this._getDOName(this.TransactionState)
    if (payload && payload[DOName]) {
      payload[DOName].eventTypeCd = response.componentData.value.eventType;
      payload[DOName].eventDt = this.commonUtilty.UIDOtoServerDODate(response.componentData.value.eventDate);
      payload[DOName].eventTm = this.commonUtilty.UIDOtoServerDOsetTime(response.componentData.value.eventTime);
      payload[DOName].causeOfDeathCd = response.componentData.value.causeOfDeath;
      payload[DOName].intimationDt = this.commonUtilty.UIDOtoServerDODate(response.componentData.value.intimationDt);
      payload[DOName].receivedDt = this.commonUtilty.UIDOtoServerDODate(response.componentData.value.receivedDt)
      if (!payload[DOName].entryDt)
        payload[DOName].entryDt = new Date();
    }
    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && !environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }

  _inputClaimsBasicDetailsComponent = {}
  _ClaimsBasicDetailsServerDOToComponentMapper(payload) {
    let DOName = this._getDOName(this.TransactionState)
    var output = {}
    if (payload && DOName && payload[DOName]) {
      output['eventType'] = payload[DOName].eventTypeCd
      if (payload[DOName].eventDt)
        output['eventDate'] = payload[DOName].eventDt
      if (payload[DOName].eventTm)
        output['eventTime'] = payload[DOName].eventTm
      output['causeOfDeath'] = this._ClaimsBasicDetailsComponentToSeverDOBusinessLogic('DEATHEVENTTYPE', payload[DOName].causeOfDeathCd, output['eventType'])
      output['intimationDt'] = payload[DOName].intimationDt
      output['receivedDt'] = payload[DOName].receivedDt
    }
    return output
  }

  _ClaimsBasicDetailsComponentToSeverDOBusinessLogic(BLRULE, sourceData, caseData?) {
    if (BLRULE === 'DEATHEVENTTYPE') {
      if (caseData === 'DEATH' && sourceData != null) {
        return null
      }
    }
  }

  _CapturedPolicyListComponentToSeverDOMapper(payload, response) {
    let DOName = this._getDOName(this.TransactionState)
    if (payload && response && DOName && payload[DOName] && (payload[DOName]['policies'] || payload[DOName]['policy'])) {
      if (this.mapperTransactionState == 'claimIntimation') {
        payload[DOName]['policies'] = this.___markClaimLoggedFl(response.componentData)
      }
      else {
        payload[DOName]['policy'] = this.___markClaimLoggedFl(response.componentData)
      }
    }
    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }

  _inputCapturedPolicyListComponent = {}
  _CapturedPolicyListServerDOToComponentMapper(payload) {
    var output = {}
    if (payload && payload['intimationDO'] && payload['intimationDO']['policies'])
      output = payload.intimationDO.policies

    if (payload && payload['claimDO'] && payload['claimDO']['policy'])
      output = payload.claimDO.policy

    if (payload && payload['investigationDO'] && payload['claimDO']['policy'])
      output = payload.investigationDO.policy

    return output
  }

  ___markClaimLoggedFl(data: Array<any>) {
    let output
    if (data && data.length && data.length > 0) {
      output = this.commonUtilty.deepCopy(data)
      output.forEach(policy => {
        policy['claimLoggedFl'] = true
      });
    }
    if (output)
      return output
    else
      return data
  }

  ___markAllRequirementsAsReceived(payload) {
    if (payload && payload['requirementDOs'] && payload['requirementDOs'].length > 0) {
      payload['requirementDOs'].forEach(requirement => {
        requirement['status'] = "RECEIVED"
      });
    }

    return payload
  }

  ___markAllChecklistAsCompleted(payload) {
    if (payload && payload['checkLists'] && payload['checkLists'].length > 0) {
      payload['checkLists'].forEach(checklistItem => {
        checklistItem['completedFl'] = true
      });
    }

    return payload
  }

  _CapturedClientListComponentToSeverDOMapper(payload, response): any {
    let role = response.componentData.role;
    let output;
    let orphanClientsRemoved = this._removeOrphanClient(payload)
    let outputAfterClientsRemoved = this._clientRoleRemoverToServerDO(orphanClientsRemoved, response)
    output = this._clientRoleMapperToServerDO(outputAfterClientsRemoved, response)
    if (output && output.clientDOs && Array.isArray(output.clientDOs)) {
      output.clientDOs.forEach((client, index) => {
        if (!client) {
          output.clientDOs.splice(index, 1)
        }
      });
    }
    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(output)}`)
    }
    return output
  }

  _CapturedAgentListComponentToSeverDOMapper(payload, response): any {
    let role = response.componentData.role;
    let output;
    // let orphanClientsRemoved = this._removeOrphanClient(payload)
    // let outputAfterClientsRemoved = this._clientRoleRemoverToServerDO(orphanClientsRemoved, response)
    output = this._agentRoleMapperToServerDO(payload, response)
    if (output && output.clientDOs && Array.isArray(output.clientDOs)) {
      output.clientDOs.forEach((client, index) => {
        if (!client) {
          output.clientDOs.splice(index, 1)
        }
      });
    }
    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(output)}`)
    }
    return output
  }

  _inputAgentListComponent = {}
  _CapturedAgentListServerDOToComponentMapper(payload) {
    let DOName = this._getDOName(this.TransactionState)
    let output = {}
    let roleNode = this.configData.AgentNodeMapper[this.TransactionState]
    if (payload) {

      //Create Nodes for All the Roles
      if (payload && payload.agentDOs && payload.agentDOs.length > 0) {
        payload.agentDOs.forEach(agentObj => {
          if (!output[agentObj.agentNum]) {
            output[agentObj.agentNum] = [agentObj.clientRefGuid]
          }
          else {
            output[agentObj.agentNum].push(agentObj.clientRefGuid)
          }
        })
      }
      console.log("agent transform server to ui output 1", JSON.stringify(output));
      //Populate ClientList for Every Role
      for (const key in output) {
        if (output.hasOwnProperty(key)) {
          let agentGuidList = this.commonUtilty.deepCopy(output[key])
          output[key] = []
          if (agentGuidList && Array.isArray(agentGuidList) && payload.clientDOs) {
            agentGuidList.forEach(agentGuid => {
              let selectedAgentData = payload.agentDOs ? payload.agentDOs.find(item => {
                if (item)
                  return item['clientRefGuid'] === agentGuid;
              }) : {}
              let policyAgentListObj = payload[DOName][roleNode].find(item => key === item.agentNum);
              if (policyAgentListObj) {
                selectedAgentData['commissionPercent'] = policyAgentListObj.commissionPercent;
                selectedAgentData['primaryFl'] = policyAgentListObj.primaryFl;
              }
              let fetchedAgentData = payload.clientDOs.find(item => {
                if (item)
                  return item['guid'] === agentGuid
              })
              let agentDO = selectedAgentData;
              let agentClientDO = fetchedAgentData
              let clientDOObj = { agentDO: {}, clientDO: {} };
              let clientDO = []
              clientDOObj.agentDO = agentDO;
              clientDOObj.clientDO = agentClientDO;
              clientDO.push(clientDOObj);
              let agentObj = { role: "AGENT", clientDO: clientDO }
              output[key].push(agentObj)
            })
          }
        }
      }
    }
    console.log("agent transform server to ui output 2", JSON.stringify(output));
    return output
  }

  _inputAllClientListComponent = {}
  _CapturedClientListServerDOToComponentMapper(payload) {
    let DOName = this._getDOName(this.TransactionState)
    let output = {}
    let clientMap = {}
    let roleNode = this.configData.StateToClientRolesNodeMapper[this.TransactionState]
    if (payload && payload[DOName] && payload[DOName][roleNode]) {

      //Create Nodes for All the Roles
      if (payload && payload[DOName] && payload[DOName][roleNode] && Array.isArray(payload[DOName][roleNode]) && payload[DOName][roleNode].length > 0)
        payload[DOName][roleNode].forEach(clientRole => {
          if (!output[clientRole.roleCd]) {
            output[clientRole.roleCd] = [clientRole.clientRefGuid]
          }
          else {
            output[clientRole.roleCd].push(clientRole.clientRefGuid)
          }

          // Extract Copy Scenario
          if (clientMap[clientRole.clientRefGuid]) {
            if (clientMap[clientRole.clientRefGuid] === "NOMINEE" && clientRole.roleCd === "CLAIMANT") {
              output['EMITTEDCLIENT'] = [clientRole.clientRefGuid]
            }
            if (clientMap[clientRole.clientRefGuid] === "CLAIMANT" && clientRole.roleCd === "NOMINEE") {
              output['EMITTEDCLIENT'] = [clientRole.clientRefGuid]
            }

            // if (clientMap[clientRole.clientRefGuid] === "OWNER") {
            //   output['EMITTEDCLIENT'] = [clientRole.clientRefGuid]
            // }
          }
          clientMap[clientRole.clientRefGuid] = clientRole.roleCd
        })

      //Populate ClientList for Every Role
      for (const key in output) {
        if (output.hasOwnProperty(key)) {
          let clientRefGuidList = this.commonUtilty.deepCopy(output[key])
          output[key] = []
          if (clientRefGuidList && Array.isArray(clientRefGuidList) && payload.clientDOs) {
            clientRefGuidList.forEach(clientRef => {
              let client = payload.clientDOs.find(item => {
                if (item)
                  return item['guid'] === clientRef
              })
              client = this.extractAttributesFromClientRoleNode(client, payload);
              if (client)
                output[key].push(client)
            })
          }
        }
      }

      //Extract PAYEES
      output = this._extratRefGuidsOfPayees(payload, output)
    }
    return output
  }

  private extractAttributesFromClientRoleNode(client: any, payload: any) {
    if (client && payload) {
      let DOName = this._getDOName(this.mapperTransactionState);
      let roleNode = this.configData.StateToClientRolesNodeMapper[this.mapperTransactionState]
      payload[DOName][roleNode].forEach(policyClient => {
        if (policyClient.roleCd != 'OWNER' && client['guid'] == policyClient['clientRefGuid']) {
          client['nomineeSplitPrct'] = policyClient['nomineeSplitPrct'] || 0;
          client['relationCd'] = policyClient['relationCd'];
        }
      });
    }

    return client
  }

  _extratRefGuidsOfPayees(payload, output) {
    let listOfPayees = []
    let nodeName = 'claimPayments'
    let DOName = this._getDOName(this.TransactionState)
    if (payload && DOName && payload[DOName] && payload[DOName][nodeName] && payload[DOName][nodeName].length) {
      payload[DOName][nodeName].forEach(claimPayment => {
        if (claimPayment)
          listOfPayees.push(claimPayment.clientRefGuid)
      });
    }
    output['PAYEE'] = this.commonUtilty.deepCopy(listOfPayees)
    return output
  }

  insuredClientData = null;
  insuredGuid = null;
  _clientRoleMapperToServerDO(payload, response) {
    let role
    let output = this.commonUtilty.deepCopy(payload)
    // if (payload && response && response.componentData && response.componentData.role) {
    //   role = response.componentData.role
    //   let selectedClientData = response.componentData.clientList.selectedClientData
    //   let clientsToBeRemoved = []
    //   if (selectedClientData) {
    //     clientsToBeRemoved = selectedClientData.filter(client => client['remove'])
    //   }
    //   let fetchedClientData = response.componentData.clientList.fetchedClientData;
    //   fetchedClientData = this.copyAdditionalAttributesFromSelectedClientItemToFetchedClientItem(response.componentData.clientList)
    //   if (fetchedClientData && Array.isArray(fetchedClientData)) {
    //     fetchedClientData.forEach(item => {
    //       let isClientToBeRemoved = clientsToBeRemoved.findIndex(clientTobeRemove => {
    //         return clientTobeRemove['guid'] == item['guid']
    //       })
    //       if (isClientToBeRemoved == -1) {
    //         output = this._pushToClientDO(output, item);
    //         output = this._addClientRole(output, item, role, this.TransactionState)
    //       }
    //     })
    //   }
    // }

    if (payload && response && response.componentData && response.componentData.role) {
      role = response.componentData.role
      let selectedClientData = response.componentData.clientList.selectedClientData
      // if (this.appMetadataHandler.featureFlags._normalizeSelectClientDataIfGuidIsNullified) {
      //   selectedClientData = this._normalizeSelectClientDataIfGuidIsNullified(selectedClientData, response);
      // }
      let clientsToBeAdded = []
      let clientFlagMap = {}
      if (selectedClientData && Array.isArray(selectedClientData)) {
        clientsToBeAdded = selectedClientData.filter(client => !client['remove'])
        clientFlagMap = this.commonUtilty.convertArrayToMap(selectedClientData, 'guid') || {}
      }
      let fetchedClientData = response.componentData.clientList.fetchedClientData
      fetchedClientData = this.copyAdditionalAttributesFromSelectedClientItemToFetchedClientItem(response.componentData.clientList)
      if (fetchedClientData && Array.isArray(fetchedClientData)) {
        fetchedClientData.forEach(item => {
          let isClientToBeAdded = clientsToBeAdded.findIndex(clientTobeRemove => {
            return clientTobeRemove['guid'] == item['guid']
          })
          if (isClientToBeAdded != -1) {
            if (clientFlagMap && clientFlagMap[item.guid] && !clientFlagMap[item.guid]['remove']) {
              //TODO take Ninad's review
              //below is the test code
              if (item['guid'] == this.insuredGuid && this.insuredClientData) {
                item = this.insuredClientData;
              }
              //test code end
              output = this._pushToClientDO(output, item);
              output = this._addClientRole(output, item, role, this.TransactionState)
            }
          }
        })
      }
    }
    return output
  }

  copyAdditionalAttributesFromSelectedClientItemToFetchedClientItem(clientList) {
    let attributes = ['nomineeSplitPrct'] // if any more attributes needed it can be added here
    if (clientList && clientList.selectedClientData && clientList.fetchedClientData) {
      if (this.commonUtilty.isArrayIterable(clientList.fetchedClientData)) {
        clientList.fetchedClientData.forEach(fetchedClientItem => {
          let selectedClientDataItem
          if (this.commonUtilty.isArrayIterable(clientList.selectedClientData)) {
            selectedClientDataItem = clientList.selectedClientData.find(selectedClientDataItem => selectedClientDataItem['guid'] == fetchedClientItem['guid'])
            if (selectedClientDataItem && fetchedClientItem) {
              attributes.forEach(attr => {
                fetchedClientItem[attr] = selectedClientDataItem[attr]
              })
            }
          }
        });
      }
    }

    return clientList.fetchedClientData
  }

  _agentRoleMapperToServerDO(payload, response) {
    console.log("captured role in _agentRoleMapperToServerDO", response.componentData.role);
    console.log("components response", response);
    console.log("agents components data", response.componentData);
    let role
    let output = this.commonUtilty.deepCopy(payload)
    if (payload && response && response.componentData && response.componentData.role) {
      role = response.componentData.role

      // if (Array.isArray(this.agentDataSet) && this.agentDataSet.length > 0) {
      let agentClientDOList = [];
      let fetchedClientData = response.componentData.agentList.fetchedClientData;
      let selectedClientData = response.componentData.agentList.selectedClientData;
      if (fetchedClientData && typeof fetchedClientData == typeof []) {
        fetchedClientData.forEach(item => {
          if (item) {
            let selectedCLient = Array.isArray(selectedClientData) ? selectedClientData.find(s => s.clientRefGuid == item.guid) : null;
            output = this._pushToClientDO(output, item);
            output = this._addPolicyAgent(output, selectedCLient, this.TransactionState);
            // output = this._addClientRole(output, item, role, this.TransactionState)
          }
        });
      }

      if (selectedClientData && typeof selectedClientData == typeof []) {
        selectedClientData.forEach(item => {
          if (item) {

            // output = this._addClientRole(output, item, role, this.TransactionState)
          }
        });
      }
      // }
    }
    return output
  }

  _removeOrphanClient(payload, roleCd?) {
    //Functionality Pending

    return payload
  }

  _clientRoleRemoverToServerDO(payload, response) {
    let role
    let output = this.commonUtilty.deepCopy(payload)
    if (payload && response && response.componentData && response.componentData.role) {
      role = response.componentData.role
      let selectedClientData = response.componentData.clientList.selectedClientData
      let clientsToBeRemoved = []
      if (selectedClientData) {
        clientsToBeRemoved = selectedClientData.filter(client => client['remove'])
      }
      let fetchedClientData = response.componentData.clientList.fetchedClientData
      if (fetchedClientData != null && typeof fetchedClientData == typeof []) {
        fetchedClientData.forEach(item => {
          let isClientToBeRemoved = clientsToBeRemoved.findIndex(clientTobeRemove => {
            return clientTobeRemove['guid'] == item['guid']
          })

          if (isClientToBeRemoved != -1) {
            output = this._removeClientRole(output, item, role, this.TransactionState);
            output = this._removeClientDO(output, item, this.TransactionState)
          }
        })
      }
    }
    return output
  }

  _removeClientRole(p, m, r, mapperTransactionState) {
    let DOName = this._getDOName(mapperTransactionState)
    let NodeName = this.configData.StateToClientRolesNodeMapper[this.TransactionState]
    let index
    if (p && p[DOName] && p[DOName][NodeName]) {
      index = p[DOName][NodeName].findIndex(x => {
        return x.clientRefGuid === m.guid && x.roleCd === r
      });

      if (index != -1) {
        p[DOName][NodeName].splice(index, 1)
      }
    }

    return p
  }

  _removeClientDO(p, m, mapperTransactionState) {
    let DOName = this._getDOName(mapperTransactionState)
    let NodeName = this.configData.StateToClientRolesNodeMapper[this.TransactionState]
    if (p && p.clientDOs && m && m.guid) {
      //Check if client has no other role existing only then delete clientDO
      let index = p.clientDOs.findIndex(x => { if (x && m) return x.guid === m.guid });
      if (index != -1) {
        if (p && p[DOName] && p[DOName][NodeName]) {
          //find the index of role, the clientDO currently has
          let roleIndex = p[DOName][NodeName].findIndex(x => {
            return x.clientRefGuid === m.guid
          });
          if (roleIndex === -1) // If -1 that means the specific clientDO has no active role in transaction
            p.clientDOs.splice(index, 1)
        }
      }
    }
    return p
  }

  _pushToClientDO(p, m) {
    if (p && p.clientDOs && m && m.guid) {
      let index = p.clientDOs.findIndex(x => { if (x && m) return x.guid === m.guid });
      if (index != -1)
        p.clientDOs.splice(index, 1, m)
      else {
        p.clientDOs.push(m)
      }
    }
    return p
  }

  _addClientRole(p, m, r, mapperTransactionState) {
    let DOName = this._getDOName(mapperTransactionState)
    let NodeName = this.configData.StateToClientRolesNodeMapper[this.TransactionState]
    let index
    if (p && p[DOName] && p[DOName][NodeName]) {
      index = p[DOName][NodeName].findIndex(x => {
        return x.clientRefGuid === m.guid && x.roleCd === r
      });

      if (index != -1) {
        let claimClientRoleItem = this.commonUtilty.deepCopy(p[DOName][NodeName][index])
        claimClientRoleItem.clientRefGuid = m.guid
        claimClientRoleItem.roleCd = r
        claimClientRoleItem.nomineeSplitPrct = m.nomineeSplitPrct || 0
        claimClientRoleItem.relationCd = m.relationCd;
        p[DOName][NodeName].splice(index, 1, claimClientRoleItem)
      }
      else {
        let claimClient = new ClaimClientRole(m.guid, r, "BYPASS")
        claimClient['relationCd'] = m.relationCd;
        claimClient['nomineeSplitPrct'] = m.nomineeSplitPrct || 0
        if (!p[DOName][NodeName]) p[DOName][NodeName] = []
        p[DOName][NodeName].push(claimClient)
      }

      //Removing Orphan Claimants
      //TODO Owner Ninad: Remove Orphan claimants
      // if (!this.appMetadataHandler.isStable && r === "CLAIMANT" && this.appMetadataHandler.claimsModes.claimantMode === 'SINGLE') {
      //   let orphanCliamantsRemoved = p[DOName][NodeName].filter(claimRole => {return ((claimRole.clientRefGuid != m.guid )&& (claimRole.roleCd != "CLAIMANT"))})
      //   p[DOName][NodeName] = this.commonUtilty.deepCopy(orphanCliamantsRemoved)
      // }
    }

    return p
  }

  _addPolicyAgent(p, m, mapperTransactionState) {
    let DOName = this._getDOName(mapperTransactionState)
    let AgentNodeName = this.configData.AgentNodeMapper[this.TransactionState]
    let index
    if (m) {
      if (p && p[DOName] && p[DOName][AgentNodeName]) {
        index = p[DOName][AgentNodeName].findIndex(x => {
          return x.agentNum === m.agentNum
        });

        if (index != -1) {
          let agentListRoleItem = this.commonUtilty.deepCopy(p[DOName][AgentNodeName][index])
          agentListRoleItem.agentNum = m.agentNum
          // agentListRoleItem.roleCd = r
          p[DOName][AgentNodeName].splice(index, 1, agentListRoleItem)
        }
        else {
          let agentPolicyClient = new PolicyAgentDO();
          // agentPolicyClient.id = m.id;
          agentPolicyClient.guid = new GuidGenerator().setGuid();
          agentPolicyClient.agentNum = m.agentNum;
          agentPolicyClient.primaryFl = m.primaryFl;
          agentPolicyClient.firstName = m.firstName;
          agentPolicyClient.lastName = m.lastName;
          // agentPolicyClient.companyContactUserId = m.companyContactUserId;
          agentPolicyClient.clientId = m.clientId;
          agentPolicyClient.channelCd = m.channel;
          // agentPolicyClient.companyCd = m.companyCd;
          // agentPolicyClient.subChannelCd = m.subChannelCd;
          // agentPolicyClient.partnerbranchCd = m.partnerbranchCd;
          // agentPolicyClient.vatApplicableFl = m.vatApplicableFl;
          // agentPolicyClient.companyBranchCd = m.companyBranchCd;
          agentPolicyClient.commissionPercent = m.commissionPercent;

          if (!p[DOName][AgentNodeName]) p[DOName][AgentNodeName] = []
          p[DOName][AgentNodeName].push(agentPolicyClient)
        }

        //Removing Orphan Claimants
        //TODO Owner Ninad: Remove Orphan claimants
        // if (!this.appMetadataHandler.isStable && r === "CLAIMANT" && this.appMetadataHandler.claimsModes.claimantMode === 'SINGLE') {
        //   let orphanCliamantsRemoved = p[DOName][NodeName].filter(claimRole => {return ((claimRole.clientRefGuid != m.guid )&& (claimRole.roleCd != "CLAIMANT"))})
        //   p[DOName][NodeName] = this.commonUtilty.deepCopy(orphanCliamantsRemoved)
        // }
      }
    } else throw `TRANSFORM ISSUE: EMPTY SELECTED CLIENT DATA FOUND FOR AGENT -- CapturedAgentListComponent`;
    return p
  }



  //differential
  _getDOName(state) {
    let output = this.configData.StateToDOMapper[state]
    let defaultClaimDOFeatureOnAndNoDOFoundInMapper = this.appMetadataHandler.featureFlags['setDOAsClaimDOIfNoDOMappingFound'] && !this.configData.StateToDOMapper[state]
    let defaultClaimDOFeatureOffAndNoDOFoundInMapper = !this.appMetadataHandler.featureFlags['setDOAsClaimDOIfNoDOMappingFound'] && !this.configData.StateToDOMapper[state]
    if (defaultClaimDOFeatureOnAndNoDOFoundInMapper) {
      return 'claimDO'
    }
    else if (defaultClaimDOFeatureOffAndNoDOFoundInMapper)
      throw "No Valid DO name for the state passed --" + state;
    else
      return output

  }

  _DocumentManagerComponentToSeverDOMapper(payload, response) {
    let DO = this._getDOName(this.TransactionState)
    if (payload && payload[DO]) {
      if (payload[DO]['requirementDOs']) {
        payload[DO]['requirementDOs'] = this.commonUtilty.deepCopy(response.componentData.requirementDOs)
      }
      if (payload[DO]['entityDocumentDOs']) {
        payload[DO]['entityDocumentDOs'] = this.commonUtilty.deepCopy(response.componentData.entityDocumentDOs)
      }
    }

    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }

    return payload
  }

  _inputDocumentManagerComponent = {};
  _DocumentManagerDOToComponentMapper(payload) {
    let DO = this._getDOName(this.TransactionState);
    let output = {
      'requirementDOs': null,
      'entityDocumentDOs': null
    };
    if (payload) {
      /* Requirements*/
      if (payload['requirementDOs']) output['requirementDOs'] = payload['requirementDOs'];
      /* Docs */
      if (payload['entityDocumentDOs']) output['entityDocumentDOs'] = payload['entityDocumentDOs'];
    }
    return payload;//output;
  }

  _ClaimDecisionComponentToSeverDOMapper(payload, response) {
    let DO = this._getDOName(this.TransactionState)
    if (payload && payload[DO]) {
      payload[DO]['adjDecisionCd'] = response.componentData.value.claimDecision
    }

    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }

  _inputClaimDecisionComponent = {};
  _ClaimDecisionDOToComponentMapper(payload) {
    let output = null;
    if (payload) {
      output = this.commonUtilty.deepCopy(payload)
    }
    return output;
  }

  _UnderwritingDecisionComponentToSeverDOMapper(payload, response) {
    let DO = this._getDOName(this.TransactionState)
    if (payload && payload[DO]) {
      payload[DO]['uwDecisionCd'] = response.componentData.value.underwritingDecision
      payload[DO]['uwDecisionValue'] = response.componentData.value.underwritingRemarks
    }

    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }

  _inputUnderwritingDecisionComponent = {};
  _UnderwritingDecisionDOToComponentMapper(payload) {
    let output = null;
    if (payload) {
      output = this.commonUtilty.deepCopy(payload)
    }
    return output;
  }

  selectedDecisionCd
  _fetchSelectedDecisionCdFromUnderwritingDecisionComponent(value) {
    this.selectedDecisionCd = value
    const componentName = "InsuredCoverageDecisionComponent"
    if (this.selectedDecisionCd) {
      this.listOfAllChildren = this.listOfAllChildren.filter(e => e != componentName)
    }
    else {
      this.listOfAllChildren = this.listOfAllChildren.filter(e => e != componentName)
      this.listOfAllChildren.push(componentName)
    }
  }

  _GenericComponentToSeverDOMapper(payload, response) {
    let DO = this.commonUtilty.getDOName(payload)
    if (payload && payload[DO] && response && response.UItoServerTransform) {
      let transformFunction = response.UItoServerTransform.bind(this)
      payload = transformFunction(payload, response)
    }
    else {
      console.group(`%cUIToServer Transformation ${response.componentName} : Failed. Either of the below four things have a problem`, 'color: white; background-color: red; padding: 2px 5px; border-radius: 2px')
      console.info('1. payload', payload)
      console.info('2. payload[DO]', payload[DO])
      console.info('3. response', response)
      console.info('4. response.UItoServerTransform', response.UItoServerTransform)
      console.groupEnd();

    }

    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }

  _inputInsuredCoverageDecisionComponent = {};
  _GenericDOToComponentMapper(payload) {
    let output = null;
    if (payload) {
      output = this.commonUtilty.deepCopy(payload)
    }
    return output;
  }

  _ClaimsBenefitComponentToSeverDOMapper(payload, response) {
    let DO = this._getDOName(this.TransactionState)
    if (payload && payload[DO]) {
      payload[DO]['claimCoverages'] = response.componentData
    }

    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }

  _inputClaimsBenefitComponent = {};
  _ClaimsBenefitDOToComponentMapper(payload) {
    let output = null;
    if (payload) {
      output = this.commonUtilty.deepCopy(payload)
    }
    return output;
  }

  _OtherPoliciesComponentToSeverDOMapper(payload, response) {
    let DO = this._getDOName(this.TransactionState)
    this.otherListNode = this.configData.OtherListNodeMapper[this.TransactionState]
    if (payload && payload[DO]) {
      payload[DO][this.otherListNode].push(...response.componentData);
    }

    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }

  _inputOtherPoliciesComponent = {};
  _OtherPoliciesDOToComponentMapper(payload) {
    let output = null;
    let DO = this._getDOName(this.TransactionState)
    this.otherListNode = this.configData.OtherListNodeMapper[this.TransactionState]
    if (payload && payload[DO]) {
      output = this.commonUtilty.deepCopy(payload[DO][this.otherListNode])
    }
    return output;
  }

  _MulticaptureBankDetailsComponentToSeverDOMapper(payload, response) {
    let DO = this._getDOName(this.TransactionState)
    let paymenNode = this.configData.PaymentNodeMapper[this.TransactionState]
    if (payload && payload[DO]) {

      if (this.TransactionState === "policyDataEntry") {
        response.componentData.forEach(receivedPaymentDetails => {

          let foundIndex = payload[DO][paymenNode].findIndex(paymentObj => paymentObj.clientRefGuid == receivedPaymentDetails.clientRefGuid)
          if (foundIndex == -1) {

            let paymentDO = new PolicyPaymentDO();
            paymentDO.accountHolderName = receivedPaymentDetails.accountHolderName;
            paymentDO.accountNum = receivedPaymentDetails.accountNum;
            paymentDO.paymentMethodCd = receivedPaymentDetails.paymentMethodCd;
            paymentDO.clientRefGuid = receivedPaymentDetails.clientRefGuid;
            payload[DO][paymenNode].push(paymentDO)
          }
          else {
            for (const key in receivedPaymentDetails) {
              if (receivedPaymentDetails.hasOwnProperty(key) && receivedPaymentDetails[key]) {
                payload[DO][paymenNode][foundIndex][key] = receivedPaymentDetails[key]
              }
            }
          }
        });
      } else {
        response.componentData.forEach(receivedPaymentDetails => {
          let foundIndex = payload[DO][paymenNode].findIndex(claimPayment => claimPayment.clientRefGuid == receivedPaymentDetails.clientRefGuid)
          if (foundIndex == -1) {
            payload[DO][paymenNode].push(receivedPaymentDetails)
          }
          else {
            for (const key in receivedPaymentDetails) {
              if (receivedPaymentDetails.hasOwnProperty(key) && receivedPaymentDetails[key]) {
                payload[DO][paymenNode][foundIndex][key] = receivedPaymentDetails[key]
              }
            }
          }
        });
      }
    }

    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }

  _inputMulticaptureBankDetailsComponent = [];
  _MulticaptureBankDetailsToComponentMapper(payload) {
    let DO = this._getDOName(this.TransactionState)
    let paymentNode = this.configData.PaymentNodeMapper[this.TransactionState];
    let clientNode = this.configData.StateToClientRolesNodeMapper[this.TransactionState];
    let output = [];
    if (payload && payload[DO]) {
      output = this.commonUtilty.deepCopy(payload[DO][paymentNode])
    }

    return output;
  }

  _SubmissionDataComponentToSeverDOMapper(payload, response) {
    console.log("payload", JSON.stringify(payload));
    console.log("response", response);
    let DO = this._getDOName(this.TransactionState)
    let coverageNodeName = this.configData.CoverageNodeMapper[this.TransactionState]

    if (!this.appMetadataHandler.featureFlags.enableDynamicRendering) {
      payload[DO].baseProductCd = response.componentData.value.productType;
      payload[DO].sumInsured = response.componentData.value.sumInsured;
      payload[DO].purposeOfInsuranceCd = response.componentData.value.purposeOfInsuranceType;
      payload[DO].baseProductFamilyCd = this.productFamilyCd;
      // payload[DO].pdfTemplateCd = this.newBusinessAppSettings.APPCONSTANTS.productFamilyCd;
      payload[DO].pdfTemplateCd = this.productFamilyCd;
      payload[DO].submissionModeCd = "PAPER"
      payload[DO].currencyCd = response.componentData.value.currencyType
      payload[DO].proposalReceivedDt = response.componentData.value.receivedDate
      payload[DO].policyCommencementDt = response.componentData.value.inceptionDate;
      payload[DO].proposalSignedDt = response.componentData.value.signedDate;
      payload[DO].policyExpiryDt = response.componentData.value.expiryDate;
      payload[DO].proposalEntryDt = new Date();
      payload[DO].policyTripDO = null;
      payload[DO].errorFl = false;
      if (this.productFamilyCd == 'LIFE') {
        payload[DO].termTypeCd = response.componentData.value.termType;
        payload[DO].parentPolicyNum = response.componentData.value.masterPolicyNo;
        payload[DO].sunInsuredTypeCd = response.componentData.value.coverType;
      }
      payload[DO].policyTerm = response.componentData.value.term;
    }

    return payload;
  }

  _inputSubmissionDataComponent = [];
  _SubmissionDataComponentMapper(payload) {
    let DO = this._getDOName(this.TransactionState)
    let output = null;
    if (payload && payload[DO]) {
      output = this.commonUtilty.deepCopy(payload)
    }
    return output;
  }

  dataSubject$
  _ProductCoveragesComponentToSeverDOMapper(payload, response) {
    let newCoverages = []
    let oldCoverages = []
    console.log("response for product coverages component", response);
    let DO = this._getDOName(this.TransactionState)
    let coverageNodeName = this.configData.CoverageNodeMapper[this.TransactionState]

    if (payload && payload[DO]) {
      if (response && Array.isArray(response.componentData)) {
        newCoverages = response.componentData.filter(item => !item.id)
        oldCoverages = response.componentData.filter(item => item.id)
      }
      if (oldCoverages && Array.isArray(oldCoverages) && oldCoverages.length > 0 &&
        payload[DO][coverageNodeName] && Array.isArray(payload[DO][coverageNodeName]) && payload[DO][coverageNodeName].length > 0) {
        oldCoverages.forEach(oldCoverage => {
          let foundIndex = payload[DO][coverageNodeName].findIndex(currentCoverage => currentCoverage.id == oldCoverage.id)
          payload[DO][coverageNodeName][foundIndex] = this.commonUtilty.deepCopy(oldCoverage)
        })
      }

      if (newCoverages && Array.isArray(newCoverages) && newCoverages.length > 0 &&
        payload[DO][coverageNodeName] && Array.isArray(payload[DO][coverageNodeName]) && payload[DO][coverageNodeName].length > 0) {
        payload[DO][coverageNodeName].push(...newCoverages)
      }
    }

    // if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
    //   console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    // }
    return payload
  }

  _inputProductCoveragesComponent = {};
  _ProductCoveragesToComponentMapper(payload) {
    let output = null;
    let DO = this._getDOName(this.TransactionState)
    let coverageNodeName = this.configData.CoverageNodeMapper[this.TransactionState]
    if (payload && payload[DO]) {
      output = this.commonUtilty.deepCopy(payload[DO][coverageNodeName])
    }
    return output;
  }

  _inputProductCoveragesBasePlanComponent = [];
  _ProductCoveragesBasePlanComponentMapper(payload) {
    let output = null;
    if (payload) {
      output = this.commonUtilty.deepCopy(payload)
    }
    return output;
  }

  _inputProductCoveragesAdditionalCoverComponent = [];
  _ProductCoveragesAdditionalCoverComponentMapper(payload) {
    let output = null;
    if (payload) {
      output = this.commonUtilty.deepCopy(payload)
    }
    return output;
  }


  getTransactionGuid(serverIO) {
    let DOName = this._getDOName(this.TransactionState)
    if (serverIO && DOName && serverIO[DOName])
      return serverIO[DOName]['guid'] || null
    else
      return null
  }


  NullValue: any = null;
  ClientCaptureFooter = null;

  tabs: any[] = [];
  nzTabPosition = 'top';
  selectedIndex = 0;
  nomineeDataSet: any[] = [];
  payerDataSet: any = [];
  insuredDataSet: any[] = [];
  primaryInsuredDataSet: any[] = [];
  agentDataSet: any[] = [];
  ownerDataSet: any[] = [];
  vehicleDataSet: any[] = [];
  membersDataSet: any[] = [];
  MULTI: any = "MULTI";
  SINGLE: any = "SINGLE";
  claimantDataSet: any[] = [];
  // policyDataSet:any[] =[];
  parentPolicyItem: any[] = [];
  policyListFetchedFromServer: any[] = [];
  enableCopyOfPrimaryInsuredAsOwner = true;
  enableCopyOfClaimantAsPayer = true;
  transactionGuid = null
  _intimationSourceCd = null

  showLastNote: boolean = true;

  // for auto rules showing names based on lookup, these var is used for that
  decisionCd: any;
  decisionTypeCd: any;
  manualUwDecisionCd: any;
  uwRuleSubType: any;
  autoUwRuleCd: any;

  /* tslint:disable-next-line:no-any */
  log(args: any[]): void {
    console.log(args);
  }

  agentList
  genericSubject$
  productSpecificationList = [];
  toggleInsuredListSubject$
  toggleCoveragesSubject$

  configPath = "/configs/policyServicing-transaction.json"
  configData: any;

  ngOnInit(): void {
    this.getConfigDataAndInitialize();
    this.subscribeAndRefreshCoveragesComponent();
    // this.fetchProducts();

  }

  dataSubmittedFlag = false
  private intializeTransaction() {
    this.interactService.transactionSubject$.pipe(take(1)).subscribe(res => {
      if (this.appMetadataHandler.featureFlags.enableMockHealthIO)
        res.IO = this.configData.healthDummyJSON;
      this.TransactionState = res.state;
      //if(res.IO ? res.IO.proposalDO ? (res.IO.proposalDO.statusCd == "DRAFT") : false : false)
      this.dataSubmittedFlag = true
      console.log("transaction state for data entry 1", this.TransactionState);
      this.transactionMasterUpdateControl = this.configData.inboxTypeToUpdateControlMapper[res.inboxType];
      this.mapperTransactionState = res.state;
      this.proposalType = res.proposalType;
      this.productFamilyCd = res.lob;
      this.selectedProduct = res.product;
      this.productSpecificationList.push(this.selectedProduct);
      this.interactService.sendGenericData(this.productSpecificationList);
      console.log("selected product data", JSON.stringify(this.selectedProduct));
      console.log("transaction state for data entry 2", this.mapperTransactionState);
      const consoleStyle = 'color: green; padding: 2px 5px; border-radius: 2px';
      console.log(`CURRENT LOB IS - ${this.productFamilyCd}`, consoleStyle);
      if (this.appMetadataHandler.featureFlags.enableAutoInitializeTransformDataPipe) {
        if (this.appMetadataHandler.featureFlags.enableUsageOfDataTransformService) {
          this.trasactionPageDataStateMap = this.dataTransformService.initializeTransactionPageDataStateMap(this.mapperTransactionState, this.configData);
          this.listOfAllChildren = this.dataTransformService.getListOfChildrenForCurrentState(this.mapperTransactionState, this.configData);
        }
        else {
          this.trasactionPageDataStateMap = this.initializeTransactionPageDataStateMap(this.mapperTransactionState, this.configData);
        }
      }
      this.nullifyPayloadInEdit = 'start';
      this._intimationSourceCd = res.intimationSourceCd;
      if (res.IO && res.IO != undefined) {
        this.payloadInEdit = this.commonUtilty.deepCopy(res.IO);
        this.flattenedPayloadInEdit = this.commonUtilty.flattenObject(this.payloadInEdit);
        console.log('FLATTENEDPAYLOAD', this.flattenedPayloadInEdit);
        localStorage.setItem('FLATTENPAYLOAD', JSON.stringify(this.flattenedPayloadInEdit));
        this.agentList = this.extractAgentDOList(res.IO);
        this.interactService.sendPolicyToPolicySummary(this.commonUtilty.getDO(this.payloadInEdit));
        // this.fetchCaseDataByGuid();
        this.autuUWRules = this.payloadInEdit['autoUwResults'];
      }
      this.tempJosn = res.IO;
      if (res.taskId)
        this.taskId = res.taskId;
      console.log("temp json ", this.tempJosn);
      if (!this.appMetadataHandler.featureFlags.enableUsageOfDataTransformService) {
        this.initializeChildSubscribers();
      }

      if (this.appMetadataHandler.featureFlags.enableUsageOfDataTransformService) {
        this.dataTransformService.initializeChildSubscribers(this.trasactionPageDataStateMap, this.mapperTransactionState).subscribe(responses => {
          if (responses)
            this._intimationTransformUItoServer(responses)
        })
      }
      if (res.IO != null)
        this.transactionGuid = this._intimationTransformServerToUI(res.IO);
    });
    this.setDefaultStatePermissionVars();
    this.closeAllModel();
  }

  getConfigDataAndInitialize() {
    // get configData from Assets
    this.apiRequestService.get(this.configPath, null, true).subscribe(response => {
      this.configData = this.commonUtilty.deepCopy(response);
      this.tabStates = this.commonUtilty.deepCopy(this.configData.tabStates)
      this.intializeTransaction();
    })
  }

  extractAgentDOList(IO) {
    let output = [];
    let DO = this.commonUtilty.getDO(IO);
    if (IO && DO) {
      let agentDOs = IO['agentDOs']
      let clientDOs = IO['clientDOs']
      let agentList = DO.caseAgents || DO.policyAgentList;
      if (this.commonUtilty.isArrayIterable(agentList)) {
        agentList.forEach(transactionAgent => {
          transactionAgent['agentDO'] = agentDOs.find(agentClientDO => agentClientDO.agentNum == transactionAgent.agentNum)
          if (transactionAgent['agentDO'])
            transactionAgent['agentClientDO'] = clientDOs.find(clientDO => clientDO.guid == transactionAgent['agentDO'].clientRefGuid || clientDO.id == transactionAgent['agentDO'].clientId)
        })
        output = this.commonUtilty.deepCopy(agentList)
      }
    }
    return output
  }

  getRulesDescription(ruleName, name) {
    if (name == 'ruleName') {
      if (this.autoUwRuleCd && this.autoUwRuleCd.length) {
        let autoUwRuleCd = this.autoUwRuleCd.filter((item) => {
          if (item.lookupKey == ruleName) { return true; }
        })
        return autoUwRuleCd.length ? autoUwRuleCd[0].lookupValue : '';
      }
    } else if (name == 'ruleSubType') {
      if (this.uwRuleSubType && this.uwRuleSubType.length) {
        let uwRuleSubType = this.uwRuleSubType.filter((item) => {
          if (item.lookupKey == ruleName) { return true; }
        })
        return uwRuleSubType.length ? uwRuleSubType[0].lookupValue : '';
      }
    } else if (name == 'decisionType') {
      if (this.decisionTypeCd && this.decisionTypeCd.length) {
        let decisionTypeCd = this.decisionTypeCd.filter((item) => {
          if (item.lookupKey == ruleName) { return true; }
        })
        return decisionTypeCd.length ? decisionTypeCd[0].lookupValue : '';
      }
    } else if (name == 'decision') {
      if (this.decisionCd && this.decisionCd.length) {
        let decisionCd = this.decisionCd.filter((item) => {
          if (item.lookupKey == ruleName) { return true; }
        })
        return decisionCd.length ? decisionCd[0].lookupValue : '';
      }
    }
  }

  ngAfterViewInit() {
    this.initializeIntimationTabs()
  }

  /* Variables */
  dataSet = [{}, {}];

  showConfirm(toStage: string): void {
    this.modalService.confirm({
      nzTitle: `<i>Are you sure you want to reverse to ${toStage}?</i>`,
      nzContent: '<b>This action cannot be undone!</b>',
      nzOkText: "Reverse",
      nzOnOk: () => console.log('OK')
    });
  }

  /* Police Station Details */
  hasPoliceStnDetails: boolean = true;

  /* Nominee Same as Claimant ? */
  // claimantSameAsNominee: boolean = true;
  private _claimantSameAsNominee: any;
  set claimantSameAsNominee(value: boolean) {

    if (value !== null) {
      this._claimantSameAsNominee = value;
    }
    else
      this._claimantSameAsNominee = false

    this.triggerClaimantSameAsNomineeChanges()
  }
  get claimantSameAsNominee(): boolean {
    return this._claimantSameAsNominee;
  }

  triggerClaimantSameAsNomineeChanges() {
    if (this._claimantSameAsNominee)
      this.setClaimantAsNominee()
    else
      this.claimantDataSet = [];
  }
  setClaimantAsNominee() {
    this.claimantDataSet = [];
    this.claimantDataSet = this.nomineeDataSet;
  }

  modalEvent$;
  closeAllModel() {
    if (this.modalEvent$ != null) this.modalEvent$.unsubscribe()
    this.modalEvent$ = this.interactService.closeModelSubject$.subscribe(res => {
      if (res) {
        this[res] = false;
      }
    })

  }

  editClientData: any
  editClient(modalFlagName, data) {
    this.editClientData = data
    console.log("edit client data in transaction", JSON.stringify(this.editClientData));
    this[modalFlagName] = true
  }

  /* PANELS */

  notesPanelOpen = false;
  notesPanel(status) { this.notesPanelOpen = !!status }

  policyPanelOpen = false;
  policyPanel(status) { this.policyPanelOpen = !!status }

  profilePanelOpen = false;
  profilePanel(status) { this.profilePanelOpen = !!status }

  corresPanelOpen = false;
  corresPanel(status) { this.corresPanelOpen = !!status }

  docuPanelOpen = false;
  docuPanel(status) { this.docuPanelOpen = !!status }

  documentManagerHandler(data) {
    this.docuPanel(data)
  }

  worksheetPanelOpen = false;
  worksheetPanel(status) { this.worksheetPanelOpen = !!status }

  workflowPanelOpen = false;
  showDropdown = false;
  workflowPanel(status, showDropdown = false) {
    this.showDropdown = showDropdown;
    this.workflowPanelOpen = !!status;
  }

  pendingPanelOpen = false;
  pendingPanel(status) { this.pendingPanelOpen = !!status }

  /* Investigator modal */
  modInvtgVis: boolean = false;

  note: string = '';
  noteCannedReply(indx: number) {
    switch (indx) {
      case 0: this.note = 'Please have a look at the ';
        break;
      case 1: this.note = 'Requesting additional investigation for ';
        break;
      case 2: this.note = 'Required Documents are not in place. Kindly do a through verification for ';
        break;
    }

  }



  /* Star */
  isStarred: boolean = false;
  /* Demo case --- only "adding" is shown */
  starThis() {
    this.message.loading('Adding to starred items', { nzDuration: 1200 });
    setTimeout(() => {
      this.message.success('#P0000107 added to you starred items', { nzDuration: 1200 });
      this.isStarred = true;
    }, 1200);
  }


  /* Rich Text Editor */
  modalCorrespNew: boolean = false;
  openCorrModal() {
    this.modalCorrespNew = true;
    this.corresPanel(0); //Close corresp panel (z index error fix)
  }
  correspondenceRichText: any = `
  <h3>Information regarding your proposal #P0000107<h3>
  <p>Dear %policyholder_name%,</p>
  <br>
  <p>We request you to submit %document_name% for %insured_name% at your earliest convenience.</p>
  <p>This would help us process your proposal </p>
  <br>
  <p>Thank you,</p><br>
  <p>Team StandardLife</p>
  `;
  handleFileUpload(data) {
    console.log(data);
  }

  correspType: string = "email";
  modSubmit: boolean = false;

  defaultUploadsList: any = [
    {
      uid: 1,
      name: 'CERTI1.pdf',
      status: 'done',
      url: 'https://image.slidesharecdn.com/sampleprojectrequirementsdocument-libraryblog-120912084344-phpapp02/95/sample-project-requirements-document-library-blog-2-728.jpg?cb=1347439456',
      thumbUrl: 'https://image.slidesharecdn.com/sampleprojectrequirementsdocument-libraryblog-120912084344-phpapp02/95/sample-project-requirements-document-library-blog-2-728.jpg?cb=1347439456'
    },
    {
      uid: 2,
      name: 'DOC45.pdf',
      status: 'done',
      url: 'https://images.template.net/wp-content/uploads/2016/03/28100800/project-process-documentation.jpg',
      thumbUrl: 'https://images.template.net/wp-content/uploads/2016/03/28100800/project-process-documentation.jpg'
    }
  ];

  uploadArray = [{}];
  addUploadRow() {
    let objPush = {};
    this.uploadArray.push(objPush)
  }
  removeUploadRow() {
    this.uploadArray.pop();
  }


  /* Bank Details */
  bank: any = {};

  fetchFromIFSC() {
    this.bank = {};
    this.message.loading('Fetching Bank Details ...', { nzDuration: 1200 });
    setTimeout(() => {
      this.bank = {
        bankName: "ICICI BANK LTD.",
        bankBranchName: "MUMBAI - FORT",
        micr: "400229016",
        city: "MUMBAI",
        address: "NAVSARI BUILDING, 240, D.N.ROAD, FORT, MUMBAI. 400001"
      }
    }, 1200);
  }

  /* Bank CHEQUE Upload */
  showUploadList = {
    showPreviewIcon: true,
    showRemoveIcon: true,
    hidePreviewIconInNonImage: true
  };
  fileList = [{
    uid: 1,
    name: 'xxx.png',
    status: 'done',
    url: "https://bse2nse.com/images/cancelled_cheque.png"
  }];
  previewImage: string | undefined = '';
  previewVisible = false;
  handlePreview = (file: NzUploadFile) => {
    this.previewImage = file.url || file.thumbUrl;
    this.previewVisible = true;
  };

  /* Event Type */
  // eventType: string = "Death";


  /* Search by Customer or Policy */
  searchCustOrPolicy: string = "customer";
  searchCustOrPolicyLoading: boolean = false;
  searchCustOrPolicyChanged() {
    this.searchCustOrPolicyLoading = true;
    this.showCustomerPolicies = false;
    setTimeout(() => { this.searchCustOrPolicyLoading = false }, 1200);
  }
  searchAddCustomer = 'search-customer';
  modSearchCustOrPolicy: boolean = false;

  showCustomerPolicies: boolean = false;
  showCustomerPoliciesName: string = '';
  viewAddCustomersPolicies(namePassed) {
    this.showCustomerPolicies = true;
    this.showCustomerPoliciesName = namePassed;
  }

  modSearchNominee: boolean = false;
  modSearchCustomerClaimant: boolean = false;

  searchPolicyClientOk() {
    this.modSearchCustOrPolicy = false
  }

  /* Modals for Hospital and Doctor */
  modHospDetails: boolean = false;
  modDocDetails: boolean = false;
  modRejectIntimation: boolean = false;


  /* ERRORS ==== */
  hasErrors: boolean = false;
  setErrorState(state: boolean) {
    if (state) {
      this.message.loading('Saving', { nzDuration: 1000 });
      setTimeout(() => {
        this.message.error('Form has errors. Please fix to continue', { nzDuration: 3000 });
        this.hasErrors = state;
        this.fakeValidationStatus = 'error';
      }, 1000);
    }
    else {
      this.hasErrors = state;
      this.fakeValidationStatus = null;
    }
  }
  /* Error Panel */
  errPanelOpen: boolean = false;
  errPanelCollapsed: boolean = false;
  errDetailsPanel(state) { this.errPanelOpen = !!state }
  errorPanelToggle() {
    //Expand/collapse visible error panel
    this.errPanelCollapsed = !this.errPanelCollapsed;
  }

  /* Jump To Tab, Highlight field */
  fakeValidationStatus: any = null;
  errJumpTo(tabIndex: number, fieldToHighlight: string) {
    /* Auto-close panel ?*/
    this.errPanelOpen = false;
    /* Process */
    setTimeout(() => {
      /* Switch Tab */
      this.selectedIndex = tabIndex;
    }, 250);
    setTimeout(() => {
      /* Focus on Field */
    }, 500);
  }

  intimationDummyRequest = null
  copySourceForPrimaryInsured: ClientList = { selectedClientData: [], fetchedClientData: [] }
  copySourceForPayer: ClientList = { selectedClientData: [], fetchedClientData: [] }
  updateClientList(data, clientType) {

    if (clientType === 'NOMINEE') {
      this.nomineeDataSet = data;
      this.interactService.sendNomineeListToBankDetails(data);
      // if (!this.nomineeClaimantFlag)
      //   this.claimantDataSet = data;
    }
    else
      this.copySourceForPrimaryInsured = data;
  }

  copySource = {}
  _EmittedClientHandler(data, targetRole?) {
    console.log("emiited client handler data", data);
    console.log("emiited client handler target role", targetRole);
    if (data && targetRole == 'PRIMARYINSURED') {
      this.copySourceForPrimaryInsured = data['clientList'];
      this.primaryInsuredDataSet = data['clientList'];
      this.refreshPrimaryInsuredTab();
    } else if (data && targetRole == 'PAYER')
      this.copySourceForPayer = data['clientList'];
      this.payerDataSet = data['clientList'];
      this.refreshPayerTab();
  }

  refreshPrimaryInsuredFlag: boolean = true;
  refreshPrimaryInsuredTab(){
    this.refreshPrimaryInsuredFlag = false;
    setTimeout(() => {
      this.refreshPrimaryInsuredFlag = true;
    }, 100);
  }
  
  refreshPayerFlag: boolean = true;
  refreshPayerTab(){
    this.refreshPayerFlag = false;
    setTimeout(() => {
      this.refreshPayerFlag = true;
    }, 100);
  }

  refreshFlag = true
  refreshClients() {
    this.refreshFlag = false
    setTimeout(() => {
      this.refreshFlag = true
    }, 100);
  }

  updatePolicyList(data) {
    if (data && data.length === 1)
      this.parentPolicyItem = data[0];
    else
      this.policyListFetchedFromServer = data
  }


  getNominee(data) {
    this.nomineeDataSet = data.componentData;
    this.closeNomineeModal();

  }

  getOwner(data) {
    this.ownerDataSet = data.componentData;
    console.log("owner data set", JSON.stringify(this.ownerDataSet));
    this.closeOwnerModal();

  }

  closeOwnerModal() {
    this.modSearchCustomerOwner = false;
  }

  getInsured(data) {
    this.insuredDataSet = data.componentData;
    this.closeInsuredModal();

  }

  getPrimaryInsured(data) {
    this.primaryInsuredDataSet = data.componentData
    this.closePrimaryInsuredModal()
  }

  getAgent(data) {
    this.agentDataSet = data.componentData;
    console.log("agentDataSet", JSON.stringify(this.agentDataSet));
    // this.closeAgentModal()
  }

  closeInsuredModal() {
    this.modSearchCustomerInsured = false;
  }

  closePrimaryInsuredModal() {
    this.modSearchCustomerPrimaryInsured = false;
  }

  closeAgentModal() {
    this.modSearchAgent = false;
  }

  getMembers(data) {
    this.membersDataSet = data.componentData;
    this.closeMemberModal();

  }
  closeMemberModal() {
    this.modSearchCustomerMembers = false;
  }

  getPayer(data: { componentData: any; }) {
    this.payerDataSet = data.componentData;
    if (this.payerDataSet && Array.isArray(this.payerDataSet.selectedClientData) && this.payerDataSet.selectedClientData.length > 0) {
      this.payerDataSet.selectedClientData.forEach((selectedCLient, index) => {
        this.commonUtilty.onChangeForPayer(selectedCLient, this.payerDataSet.fetchedClientData[index], true).subscribe((resp: any) => {
          this.interactService.sendPayeeListToBankDetails(resp)
        })
      })
    }

    this.closePayerModal();

  }
  closePayerModal() {
    this.modSearchCustomerPayer = false;
  }

  getVehicle(data) {
    this.vehicleDataSet = data.componentData;
    this.closeVehicleModal();

  }
  closeVehicleModal() {
    this.modSearchCustomerVehicle = false;
  }

  getPolicyList(data) {

    if (data && data.length === 1)
      this.parentPolicyItem = data[0];
    else
      this.policyListFetchedFromServer = data

  }

  closeNomineeModal() {
    this.modSearchNominee = false;
  }

  getClaimant(data) {
    this.claimantDataSet = data.componentData;
    // this.updateClientList(this.claimantDataSet,"Claimant");
    this.closeClaimantModal();

  }

  closeClaimantModal() {
    this.modSearchCustomerClaimant = false;
  }

  pingChildToGetData() {
    this.interactService.pingChildToReact(this.route.routeConfig.component.name);
  }

  pingToClientSearchForNominee() {
    this.pingChildToGetData();
    this.modSearchCustomerClaimant = false;
  }

  pingToAgentSearchForData() {
    this.interactService.pingAgentSearch(true);
    this.modSearchAgent = false;
  }

  getDateString(rawDate) {
    let dateString
    if (rawDate != null) {

      dateString = moment(rawDate).format('DD MMM YYYY');
    }
    else {
      dateString = 'N/A'
    }
    return dateString
  }

  removeNominee(data, list, uniqueID) {
    this.nomineeDataSet = this.commonUtilty.removeItemFromListUnSorted(data, list, uniqueID);
  }

  removeClaimant(data, list, uniqueID, index) {
    this.claimantDataSet = this.commonUtilty.removeItemFromListUnSorted(data, list, uniqueID);
    this.interactService.removeClient('CLAIMANT', data, index, list)
  }

  pingToClientSearchForClaimant() {
    this.pingChildToGetData();
    this.modSearchNominee = false;
  }


  metaDataArray = [
    {
      "key": "proposalNum",
      "description": "Proposal Number",
      "isVisible": true
    },
    {
      "key": "clmIntimationNum",
      "description": "Claim Number",
      "isVisible": true
    },
    {
      "key": "commencementDt",
      "description": "Policy Commencement",
      "isVisible": true
    },
    {
      "key": "Insured",
      "description": "Insured Name",
      "isVisible": true,
    },
    {
      "key": "claimedAmt",
      "description": "Claimed Amount",
      "isVisible": true,
    },
    {
      "key": "MEMBERS",
      "description": "Members Name",
      "isVisible": true,
    }
  ];


  // for static data content
  permissions: any = [];
  showLastComment: boolean = false;
  modHospitalizationDetails: boolean = false;
  modSearchAddHosp: boolean = false;
  modSearchAddDoctor: boolean = false;
  tempBenefit1: string = `250000`;
  tempBenefit2: string = `20000`;
  tempBenefit3: string = `350000`;
  tempBenefitTotal: string = `150000`;

  /* Hospital Tabs: Hide/Show */
  tabHosp: any = "search-hosp";
  /* Doctor Tabs: Hide/Show */
  tabDoc: any = "search-doc";

  setDefaultStatePermissionVars() {
    this.permissions = {
      basic: { show: true, edit: true },
      insured: { show: true, edit: true },
      nominee_claimant: { show: true, edit: true },
      hospitalization: { show: true, edit: true },
      bank_details: { show: true, edit: true },
      benefit: { show: true, edit: true },
      payment_breakup: { show: true, edit: true },
      payout_details: { show: true, edit: true },
      adj_claim_decision: { show: true, edit: true },
      investigation_report: { show: true, edit: true },
      other_policies: { show: true, edit: true },
      analytics: { show: true, edit: true },
    };
    /* Set other defaults */
    this.showLastComment = true;
  }

  reffrelUserType: any = null;
  modalTitle: any = null;
  referOrSubmitMode(roleUserType) {
    if (roleUserType == 'INVESTIGATOR') {
      this.modalTitle = "Assign Investigator"
    } else {
      this.modalTitle = "Refer Task"

    }
    this.reffrelUserType = roleUserType
    this.interactService.referToRoleUserType(roleUserType)
    this.modInvtgVis = true;

  }
  refertoUser() {
    if (this.taskId && this.assigneeUser) {
      this.interactService.referToRoleUserType$.pipe(take(1))
        .subscribe(o => {
          let value = this.ReferMap[o]
          let DOName = this._getDOName(this.mapperTransactionState)
          let taskIO: TaskIO = new TaskIO()
          taskIO.assignedto = this.assigneeUser
          taskIO.taskCd = value;
          taskIO.objectName = 'ClaimDO'
          taskIO.entityGuid = this.payloadInEdit[DOName].guid
          this.workqueueService.createTask(taskIO).subscribe(resp => {
            this.modInvtgVis = false;

          });
        })

    }
  }

  ReferMap = {
    INVESTIGATOR: "claimInvestigtion",
    UNDERWRITER: "claimUWReferral",
    REINSURER: "claimReinsReferral",
  }
  //For Refer Modal


  /* Rules */
  //rulesData = rulesDataObj;


  fetchProducts(productFamilyCd) {
    this.workqueueService.fetchProducts(productFamilyCd)
      .subscribe(jsonResp => {
        if (jsonResp && jsonResp.length) {
          jsonResp.forEach((criteria: any) => {
            if (criteria && Object.keys(criteria).length) {
              this.productData.push(criteria);
            } else {
              this.productData = [];
            }

            // let searchCriteriaDO = new SearchAPIMetaDataDO();
            // searchCriteriaDO.key = criteria.attributeName;
            // searchCriteriaDO.keyDescription = criteria.description;
            // searchCriteriaDO.valueInputType = criteria.attributeDataTypeCd;
            // searchCriteriaDO.lookupName = criteria.attr.ibuteLookupCd;
            // searchCriteriaDO.lookup = [];
            // searchCriteriaDO.enable = true;
            // searchCriteriaDO.isMandatory = criteria.mandatoryFl == 'YES' ? true : false;
            // this.CRITERIALOOKUP.push(searchCriteriaDO)
          })

          if (this.tempJosn) {
            let DO = this._getDOName(this.TransactionState)
            let selectedProductData = this.productData.filter(item => item.productId === this.payloadInEdit[DO].baseProductCd)
            console.log("selected product data", JSON.stringify(selectedProductData));
            this.productSpecificationList = selectedProductData
            this.interactService.sendGenericData(this.productSpecificationList);
          }
        }
        console.log("product data when fetching from API", JSON.stringify(this.productData));
      })
  }

  autuUWRules = [];
  fetchCaseDataByGuid() {
    if (this.payloadInEdit && this.payloadInEdit['caseDO']) {
      let guid = this.payloadInEdit['caseDO'].guid;
      this.policyService.getCaseByGuid(guid).subscribe(response => {
        console.log("case response", JSON.stringify(response));
        if (response)
          this.autuUWRules = response.autoUwResults;
      })
    }
  }

  setMainProductData(payload, response, DO, coverageNodeName) {
    let clientGuid = null;
    let clientId = null;
    let PolicyClientNode = this.configData.StateToClientRolesNodeMapper[this.mapperTransactionState];
    if (payload && payload[DO]) {
      let policyClient = payload[DO][PolicyClientNode].find(item => item.roleCd === 'PRIMARYINSURED')
      clientGuid = policyClient.clientRefGuid;
      clientId = policyClient.clientId;
    }

    let basePlanCoverageObj = new PolicyCoverageDO();
    basePlanCoverageObj.planTypeCd = 'BASEPLAN';
    basePlanCoverageObj.guid = new GuidGenerator().setGuid();
    basePlanCoverageObj.productCd = response['BasePlanComponent'].productCd;
    basePlanCoverageObj.sumInsured = response['BasePlanComponent'].value.sumInsured;
    basePlanCoverageObj.planOptionCd = response['BasePlanComponent'].value.planTypeCd;
    // basePlanCoverageObj.associationType = response['BasePlanComponent'].value.packageType;
    basePlanCoverageObj.term = response['BasePlanComponent'].value.term;
    let coveragesInsuredDO = new PolicyCoverageInsuredDO();
    coveragesInsuredDO.clientRefGuid = clientGuid;
    coveragesInsuredDO.clientId = clientId;
    coveragesInsuredDO.roleCd = "PRIMARYINSURED";

    basePlanCoverageObj.policyCoverageInsuredList.push(coveragesInsuredDO);

    if (Array.isArray(basePlanCoverageObj.policyCoverageScheduleList)) {
      if (response.componentData.value.term === basePlanCoverageObj.policyCoverageScheduleList.length) {
        // do nothing
      } else {
        basePlanCoverageObj.policyCoverageScheduleList = [];
        let policyTerm = response.componentData.value.term;
        for (let i = 0; i < policyTerm; i++) {
          let policyCoverageSchedule = new PolicyCoverageScheduleDO();
          policyCoverageSchedule.productTypeCd = basePlanCoverageObj.productCd;
          policyCoverageSchedule.policyYear = i + 1;

          basePlanCoverageObj.policyCoverageScheduleList.push(policyCoverageSchedule);
        }
      }
    }

    payload[DO][coverageNodeName].push(basePlanCoverageObj);

    let premiumBreakup = new PolicyPremiumBreakupDO();
    payload[DO]['premiumBreakupList'].push(premiumBreakup);

    return payload;
  }

  checkIfMainProductExists(payload) {
    let mainProductFound = false;
    let DO = this._getDOName(this.TransactionState)
    let coverageNodeName = this.configData.CoverageNodeMapper[this.TransactionState]
    if (payload && payload[DO]) {
      if (payload[DO][coverageNodeName] && payload[DO][coverageNodeName].length && payload[DO][coverageNodeName].length > 0) {
        payload[DO][coverageNodeName].forEach(coverObj => {
          if (coverObj.planTypeCd === 'BASEPLAN')
            mainProductFound = true;
        });
      }
    }
    return mainProductFound;
  }

  getMandatoryCoverages(list) {
    this.mandatoryCoveragesList = [];
    if (this.commonUtilty.isArrayIterable(list))
      this.mandatoryCoveragesList = this.commonUtilty.deepCopy(list);
  }

  setMandatoryCoverages(payload) {
    let CoveragesNode = this.configData.CoverageNodeMapper[this.mapperTransactionState];
    let CoveragesInsuredNode = this.configData.CoverageInsuredNodeMapper[this.mapperTransactionState];
    let DO = this._getDOName(this.TransactionState)
    if (this.commonUtilty.isArrayIterable(this.mandatoryCoveragesList)) {
      this.mandatoryCoveragesList.forEach(coverage => {
        let coverageDO = new PolicyCoverageDO();
        coverageDO.productCd = coverage.riderCd;
        let riderAttribute = coverage.productRiderAttributelist && coverage.productRiderAttributelist.length > 0 ? coverage.productRiderAttributelist.find(item => item.vocabularyCd == 'SumInsured') : null;
        if (riderAttribute) {
          coverageDO.sumInsured = riderAttribute.configuredValue;
        }
        coverage.planTypeCd = 'RIDER';
        if (this.commonUtilty.isArrayIterable(this.customHookService.insuredList)) {
          this.customHookService.insuredList.forEach(insured => {
            let coverageInsured = new PolicyCoverageInsuredDO();
            coverageInsured.clientRefGuid = insured.clientDO.guid;
            coverageInsured.clientId = insured.clientDO.id;
            coverageInsured.roleCd = "INSURED";
            coverageDO[CoveragesInsuredNode].push(coverageInsured);
          })
        }
        payload[DO][CoveragesNode] = this.commonUtilty.uniquePushInArray(payload[DO][CoveragesNode], coverageDO, 'productCd');
      })
    }

    return payload;
  }

  emittedComponentData = {}
  manageInsuredAndCoveragesDecisions(policyDecision) {
    this.givenPolicyDecision = policyDecision;
    this.refreshCoveragesDecision = false;
    setTimeout(() => {
      this.refreshCoveragesDecision = true;
    }, 300);
  }


}